<template>
  <div>
    <!-- 功能导航 -->
    <div class="function-nav">
        <div class="nav-tabs">
          <span v-for="tab in tabs" :key="tab.label" class="tab" :class="{active: activeTab === tab.label}" @click="switchTab(tab)">{{ tab.label }}</span>
        </div>
        <div class="refresh-btn" @click="refreshCurrentTab">
          <img src="images/alram/e2a3cbe1ebfd6d188b1927e610af0e25.png" />
          <span>刷新</span>
        </div>
    </div>
      <!-- tab内容区 -->
      <div v-if="activeTab === '实时告警'">
        <!-- 搜索筛选区域 -->
        <div class="search-section search-section-new">
          <form class="search-form-2x2">
            <div class="form-fields">
              <div class="form-item">
                <label>告警类型：</label>
                <select class="form-input" v-model="alarmQuery.type">
                  <option value="超速告警">超速告警</option>
                </select>
              </div>
              <!-- <div class="form-item">
                <label>所属厂区：</label>
                <select class="form-input" v-model="alarmQuery.park">
                  <option value="">全部</option>
                  <option value="A">泰山路</option>
                </select>
              </div> -->
              <div class="form-item">
                <label>设备编号：</label>
                <select class="form-input" v-model="alarmQuery.deviceNumber">
                  <option value="">全部</option>
                  <option value="100">100</option>
                  <option value="103">103</option>
                  <option value="105">105</option>
                  <option value="106">106</option>
                  <option value="107">107</option>
                </select>
              </div>
              <div class="form-item">
                <label>安装位置：</label>
                <select class="form-input" v-model="alarmQuery.location">
                  <option value="">全部</option>
                  <option value="东门南北方向">东门南北方向</option>
                  <option value="北门南北方向">北门南北方向</option>
                  <option value="C门东西方向">C门东西方向</option>
                  <option value="B门东西方向">B门东西方向</option>
                  <option value="A门东西方向">A门东西方向</option>
                </select>
              </div>
            </div>
            <div class="form-btns">
              <button type="button" class="search-btn-green" @click="searchAlarm">
                查询
              </button>
              <button type="button" class="search-btn-green" @click="printAlarm">
                打印
              </button>
            </div>
          </form>
        </div>

        <!-- 数据展示区域 -->
        <div class="data-section">
          <div class="data-layout">
            <!-- 左侧图片展示区 -->
            <div class="image-preview">
              <div class="preview-header">
                <span class="preview-title">实时抓拍</span>
                <span class="preview-subtitle">ICR</span>
              </div>
              <div class="preview-content">
                <img :src="currentImage" class="preview-image" />
              </div>
            </div>

            <!-- 右侧告警信息列表 -->
            <div class="alarm-list">
              <h3 class="list-title">实时收图列表</h3>
              <div class="table-container">
                <table class="data-table">
                  <thead>
                    <tr>
                      <th>车牌</th>
                      <th>车道违规</th>
                      <th>车速</th>
                      <th>更新时间</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in pagedAlarmList" 
                        :key="index" 
                        @click="selectAlarm(item)"
                        :class="{ 'active': selectedAlarm === item }">
                      <td>{{ item.plateNumber }}</td>
                      <td>{{ item.violation }}</td>
                      <td>{{ item.speed }}</td>
                      <td>{{ item.updateTime }}</td>
                    </tr>
                    <tr v-if="pagedAlarmList.length === 0">
                      <td colspan="4" style="text-align:center;color:#bbb;">暂无数据</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="pagination">
                <button class="page-btn" :disabled="alarmPage===1" @click="changeAlarmPage(1)">«</button>
                <button class="page-btn" :disabled="alarmPage===1" @click="changeAlarmPage(alarmPage-1)">‹</button>
                <span v-for="p in displayAlarmPages" :key="p">
                  <button class="page-btn" :class="{active:alarmPage===p}" @click="changeAlarmPage(p)">{{p}}</button>
                </span>
                <button class="page-btn" :disabled="alarmPage===alarmTotalPages" @click="changeAlarmPage(alarmPage+1)">›</button>
                <button class="page-btn" :disabled="alarmPage===alarmTotalPages" @click="changeAlarmPage(alarmTotalPages)">»</button>
                <div class="page-jump">
                  <input type="text" v-model="alarmPageInput" style="width:50px;" />
                  <button class="jump-btn" @click="jumpAlarmPage">跳转</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="activeTab === '历史查询'">
        <div v-if="historyViewMode === 'list'">
          <!-- 历史查询筛选表单 -->
          <div class="search-section search-section-new">
            <form class="search-form-2x2">
              <div class="form-fields">
                <!-- <div class="form-item">
                  <label>所属厂区：</label>
                  <select class="form-input" v-model="historyQuery.park">
                    <option value="">泰山路</option>
                  </select>
                </div> -->
                <div class="form-item">
                  <label>车牌号：</label>
                  <input class="form-input" v-model="historyQuery.plateNumber" placeholder="全部" />
                </div>


                <div class="form-item">
                  <label>安装位置：</label>
                  <select class="form-input" v-model="historyQuery.location">
                    <option value="">全部</option>
                    <option value="东门南北方向">东门南北方向</option>
                    <option value="北门南北方向">北门南北方向</option>
                    <option value="C门东西方向">C门东西方向</option>
                    <option value="B门东西方向">B门东西方向</option>
                    <option value="A门东西方向">A门东西方向</option>
                  </select>
                </div>
                <div class="form-item">
                  <label>设备编号：</label>
                  <select class="form-input" v-model="historyQuery.deviceNumber">
                    <option value="">全部</option>
                    <option value="100">100</option>
                    <option value="103">103</option>
                    <option value="105">105</option>
                    <option value="106">106</option>
                    <option value="107">107</option>
                  </select>
                </div>
                <div class="form-item">
                  <label>开始日期：</label>
                  <input class="form-input" type="date" v-model="historyQuery.startDate" placeholder="选择开始日期" />
                </div>
                <div class="form-item">
                  <label>结束日期：</label>
                  <input class="form-input" type="date" v-model="historyQuery.endDate" placeholder="选择结束日期" />
                </div>
              </div>
              <div class="form-btns">
                <button type="button" class="search-btn-green" @click="searchHistory">
                  查询
                </button>
                <button type="button" class="search-btn-green" @click="printHistory">
                  打印
                </button>
                <!-- <button type="button" class="search-btn-blue" @click="debugHistoryState">
                  调试状态
                </button> -->

              </div>
            </form>
          </div>
          <!-- 历史查询表格 -->
          <div class="data-section">
            <div class="table-container">
              <table class="data-table">
                <thead>
                  <tr>
                    <th>序号</th>
                    <th>设备编号</th>
                    <th>设备名称</th>
                    <th>安装位置</th>
                    <th>车牌号</th>
                    <th>违规时间</th>
                    <th>车速</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, idx) in pagedHistoryList" :key="item.id">
                    <td>{{ (historyPage-1)*historyPageSize + idx + 1 }}</td>
                    <td>{{ item.deviceNumber }}</td>
                    <td>{{ item.deviceName }}</td>
                    <td>{{ item.location }}</td>
                    <td>{{ item.plateNumber }}</td>
                    <td>{{ item.violationTime }}</td>
                    <td>{{ item.speed }}</td>
                    <td>
                      <div class="table-action-btns">
                        <button class="search-btn-green" style="padding:4px 8px;" @click="showHistoryView(item)">
                          详情
                        </button>
                        <!-- <button class="search-btn-green" style="padding:4px 8px;" @click="showHistoryEdit(item)">
                          编辑
                        </button> -->
                      </div>
                    </td>
                  </tr>
                  <tr v-if="pagedHistoryList.length === 0">
                    <td colspan="9" style="text-align:center;color:#bbb;">暂无数据</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- 分页 -->
            <div class="pagination">
              <button class="page-btn" :disabled="historyPage===1" @click="changeHistoryPage(1)">«</button>
              <button class="page-btn" :disabled="historyPage===1" @click="changeHistoryPage(historyPage-1)">‹</button>
              <span v-for="p in displayHistoryPages" :key="p">
                <button class="page-btn" :class="{active:historyPage===p}" @click="changeHistoryPage(p)">{{p}}</button>
              </span>
              <button class="page-btn" :disabled="historyPage===historyTotalPages" @click="changeHistoryPage(historyPage+1)">›</button>
              <button class="page-btn" :disabled="historyPage===historyTotalPages" @click="changeHistoryPage(historyTotalPages)">»</button>
              <div class="page-jump">
                <input type="text" v-model="historyPageInput" style="width:50px;" />
                <button class="jump-btn" @click="jumpHistoryPage">跳转</button>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="historyViewMode === 'view'" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
          <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
              <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">历史记录详情</span>
              <button @click="closeHistoryDetail" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
            </div>
            <div style="display:flex;flex-direction:column;gap:18px;">
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">设备编号：</span><input class="form-input" :value="historyCurrentItem.deviceNumber" style="width:400px;" readonly /></div>
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">设备名称：</span><input class="form-input" :value="historyCurrentItem.deviceName" style="width:400px;" readonly /></div>
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">安装位置：</span><input class="form-input" :value="historyCurrentItem.location" style="width:400px;" readonly /></div>
              <div v-if="historyCurrentItem && (historyCurrentItem.imageUrl || historyCurrentItem.imageData)" style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">图片：</span>
                <img v-if="historyCurrentItem.imageUrl" 
                     :src="historyCurrentItem.imageUrl" 
                     alt="图片" 
                     style="max-width:320px;max-height:200px;margin-bottom:0;border-radius:8px;box-shadow:0 2px 8px #0001;cursor:pointer;" 
                     @click="previewHistoryImage(historyCurrentItem.imageUrl)" />
                <div v-else style="display:flex;align-items:center;gap:8px;">
                  <span style="color:#666;">正在加载图片...</span>
                  <button class="search-btn-green" style="padding:4px 8px;" @click="loadHistoryImage(historyCurrentItem)">
                    重新加载
                  </button>
                </div>
              </div>
              <!-- <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">车辆类型：</span><input class="form-input" :value="historyCurrentItem.vehicleType" style="width:400px;" readonly /></div> -->
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">车牌号：</span><input class="form-input" :value="historyCurrentItem.plateNumber" style="width:400px;" readonly /></div>
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">违规时间：</span><input class="form-input" :value="historyCurrentItem.violationTime" style="width:400px;" readonly /></div>
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">车速：</span><input class="form-input" :value="historyCurrentItem.speed" style="width:400px;" readonly /></div>
            </div>
          </div>
        </div>
        <div v-else-if="historyViewMode === 'edit'">
          <div style="display:flex;justify-content: flex-end;align-items:center;height:40px;">
            <button @click="closeHistoryDetail" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
          </div>
          <div class="data-section history-edit-section">

            <div class="history-edit-row">设备编号：<input v-model="historyCurrentItem.deviceNumber" class="form-input" /></div>
            <div class="history-edit-row">设备名称：<input v-model="historyCurrentItem.deviceName" class="form-input" /></div>
            <div class="history-edit-row">安装位置：<input v-model="historyCurrentItem.location" class="form-input" /></div>
            <img v-if="historyCurrentItem && historyCurrentItem.imageUrl" :src="historyCurrentItem.imageUrl" alt="图片" style="max-width:320px;max-height:200px;margin-bottom:24px;border-radius:8px;box-shadow:0 2px 8px #0001;" />
            <!-- <div class="history-edit-row">车辆类型：<input v-model="historyCurrentItem.vehicleType" class="form-input" /></div> -->
            <div class="history-edit-row">车牌号：<input v-model="historyCurrentItem.plateNumber" class="form-input" /></div>
            <div class="history-edit-row">违规时间：<input v-model="historyCurrentItem.violationTime" class="form-input" /></div>
            <div style="display:flex;justify-content:center;margin-top:32px;">
              <button class="search-btn-green" @click="closeHistoryDetail">保存</button>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="activeTab === '点位管理'">
        <!-- 新增设备弹窗 -->
        <div v-if="pointAddMode" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
          <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
              <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">新增设备</span>
              <button @click="closePointAdd" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
            </div>
            <div style="display:flex;flex-direction:column;gap:18px;">
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">设备编号：</span>
                <input class="form-input" v-model="pointAddItem.fac_id" style="width:400px;" placeholder="请输入设备编号" />
              </div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">设备类型：</span>
                <select v-model="pointAddItem.fac_model" class="form-input" style="width:400px;">
                  <option value="摄像头">摄像头</option>
                  <option value="表具">表具</option>
                </select>
              </div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">设备名称：</span>
                <input class="form-input" v-model="pointAddItem.fac_name" style="width:400px;" />
              </div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">设备状态：</span>
                <input class="form-input" v-model="pointAddItem.fac_state" style="width:400px;" />
              </div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">设备点位信息：</span>
                <input class="form-input" v-model="pointAddItem.fac_point" style="width:400px;" placeholder="请输入设备点位信息" />
              </div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">详细位置：</span>
                <input class="form-input" v-model="pointAddItem.detail_location" style="width:400px;" />
              </div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">所属厂区：</span>
                <input class="form-input" v-model="pointAddItem.factory_area" style="width:400px;" />
              </div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">生产厂家：</span>
                <input class="form-input" v-model="pointAddItem.manufacturer" style="width:400px;" />
              </div>
              <div style="display:flex;align-items:flex-start;">
                <span style="width:120px;text-align:left;">安装说明：</span>
                <textarea class="form-input" v-model="pointAddItem.install_instruction" style="width:400px;height:60px;" />
              </div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">安装日期：</span>
                <input class="form-input" type="datetime-local" v-model="pointAddItem.install_date" placeholder="选择安装日期" style="width:400px;" />
              </div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">安装图片：</span>
                <div style="margin-left:12px;">
                  <label style="cursor:pointer;">
                    <input type="file" accept="image/*" style="display:none;" @change="onPointAddImageChange" />
                    <div v-if="!pointAddItem.install_photo" style="width:80px;height:80px;border:1px solid #ddd;border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:36px;color:#888;background:#fafbfc;">
                      <i class="el-icon-camera"></i>+
                    </div>
                    <img v-else :src="pointAddItem.install_photo" style="width:80px;height:80px;border-radius:8px;object-fit:cover;border:1px solid #ddd;" />
                  </label>
                </div>
              </div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">申报人：</span>
                <input class="form-input" v-model="pointAddItem.applicant" style="width:400px;" />
              </div>
            </div>
            <div style="display:flex;justify-content:flex-end;gap:16px;margin-top:32px;">
              <button class="search-btn-green" @click="savePointAdd" style="min-width:80px;">保存</button>
           </div>
          </div>
        </div>
        <!-- 详情弹窗 -->
        <div v-else-if="pointDetailMode === 'view'" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
          <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
              <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">设备详情</span>
              <button @click="closePointDetailModal" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
            </div>
            <div style="display:flex;flex-direction:column;gap:18px;">
              <div v-for="(value, key) in pointDetailFields" :key="key" style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">{{ pointFieldLabels[key] || key }}：</span>
                <div v-if="key === 'fac_id'" style="width:400px;">
                  <input class="form-input" :value="value" style="width:100%;" readonly />
                </div>  
                <div v-else-if="key === 'fac_point'" style="width:400px;">
                  <input class="form-input" :value="value" style="width:100%;" readonly />
                </div>
                <input v-else class="form-input" :value="value" style="width:400px;" readonly />
              </div>
              <div style="display:flex;align-items:center;">安装图片：
                <div style="margin-left:12px;">
                  <img v-if="pointDetailItem.install_photo_url" :src="pointDetailItem.install_photo_url" style="width:80px;height:80px;border-radius:8px;object-fit:cover;border:1px solid #ddd;cursor:pointer;" @click="previewImage(pointDetailItem.install_photo_url)" />
                  <div v-else style="width:80px;height:80px;border:1px solid #ddd;border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:36px;color:#888;background:#fafbfc;">无</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 编辑弹窗 -->
        <div v-else-if="pointDetailMode === 'edit'" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
          <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
              <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">编辑设备</span>
              <button @click="closePointDetailModal" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
            </div>
            <div style="display:flex;flex-direction:column;gap:18px;">
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">设备编号：</span>
                <input class="form-input" v-model="pointDetailItem.fac_id" style="width:400px; " placeholder="请输入设备编号" readonly/>
              </div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">设备类型：</span>
                <select v-model="pointDetailItem.fac_model" class="form-input" style="width:400px;">
                  <option value="摄像头">摄像头</option>
                  <option value="表具">表具</option>
                </select>
              </div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">设备名称：</span>
                <input class="form-input" v-model="pointDetailItem.fac_name" style="width:400px;" />
              </div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">设备状态：</span>
                <input class="form-input" v-model="pointDetailItem.fac_state" style="width:400px;" />
              </div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">设备点位信息：</span>
                <input class="form-input" v-model="pointDetailItem.fac_point" style="width:400px;" placeholder="请输入设备点位信息" />
              </div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">详细位置：</span>
                <input class="form-input" v-model="pointDetailItem.detail_location" style="width:400px;" />
              </div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">所属厂区：</span>
                <input class="form-input" v-model="pointDetailItem.factory_area" style="width:400px;" />
              </div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">生产厂家：</span>
                <input class="form-input" v-model="pointDetailItem.manufacturer" style="width:400px;" />
              </div>
              <div style="display:flex;align-items:flex-start;">
                <span style="width:120px;text-align:left;">安装说明：</span>
                <textarea class="form-input" v-model="pointDetailItem.install_instruction" style="width:400px;height:60px;" />
              </div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">安装日期：</span>
                <input class="form-input" type="datetime-local" v-model="pointDetailItem.install_date" placeholder="选择安装日期" style="width:400px;" />
              </div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">安装图片：</span>
                <div style="margin-left:12px;">
                  <label style="cursor:pointer;">
                    <input type="file" accept="image/*" style="display:none;" @change="onPointDetailImageChange" />
                    <div v-if="!pointDetailItem.install_photo_url" style="width:80px;height:80px;border:1px solid #ddd;border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:36px;color:#888;background:#fafbfc;">
                      <i class="el-icon-camera"></i>+
                    </div>
                    <img v-else :src="pointDetailItem.install_photo_url" style="width:80px;height:80px;border-radius:8px;object-fit:cover;border:1px solid #ddd;cursor:pointer;" @click="previewImage(pointDetailItem.install_photo_url)" />
                  </label>
                </div>
              </div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">申报人：</span>
                <input class="form-input" v-model="pointDetailItem.applicant" style="width:400px;" />
              </div>
            </div>
            <div style="display:flex;justify-content:flex-end;gap:16px;margin-top:32px;">
              <button class="search-btn-green" @click="savePointEdit" style="min-width:80px;">保存</button>
              <button class="search-btn-green" @click="closePointDetailModal" style="background:#eee;color:#333;min-width:80px;">取消</button>
            </div>
          </div>
        </div>
        <!-- 点位管理列表视图 -->
        <div v-else-if="pointViewMode === 'list'">
          <!-- 点位管理列表视图 -->
          <div class="search-section search-section-new">
            <form class="search-form-2x2">
              <div class="form-fields" style="display: flex; gap: 140px; align-items: center;">
                <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
                  <label style="min-width: 80px; margin-right: 8px;">设备编号：</label>
                  <select class="form-input" v-model="pointQuery.deviceNumber" style="flex: 1;">
                    <option value="">全部</option>
                    <option value="100">100</option>
                    <option value="103">103</option>
                    <option value="105">105</option>
                    <option value="106">106</option>
                    <option value="107">107</option>
                  </select>
                </div>
                <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
                  <label style="min-width: 80px; margin-right: 8px;">安装位置：</label>
                  <select class="form-input" v-model="pointQuery.location" style="flex: 1;">
                    <option value="">全部</option>
                    <option value="东门南北方向">东门南北方向</option>
                    <option value="北门南北方向">北门南北方向</option>
                    <option value="C门东西方向">C门东西方向</option>
                    <option value="B门东西方向">B门东西方向</option>
                    <option value="A门东西方向">A门东西方向</option>
                  </select>
                </div>
              </div>
              <div class="form-btns">
                <button type="button" class="search-btn-green" @click="searchPoint">
                  搜索
                </button>
                <button type="button" class="search-btn-green" @click="printPoint">
                  打印
                </button>
              </div>
            </form>
          </div>
          <!-- 新增按钮 -->
          <div style="margin: 0 0 16px 8px;">
            <button class="search-btn-green" @click="addPoint">新增设备</button>
          </div>
          <!-- 点位管理表格 -->
          <div class="data-section">
            <div class="table-container">
              <table class="data-table">
                <thead>
                  <tr>
                    <th>序号</th>
                    <th>设备编号</th>
                    <th>设备名称</th>
                    <th>状态</th>
                    <th>点位</th>
                    <th>生产厂家</th>
                    <th>所属厂区</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, idx) in pagedPointList" :key="item.id || idx">
                    <td>{{ item.id ? (pointPage-1)*pointPageSize + idx + 1 : '' }}</td>
                    <td>{{ item.deviceNumber }}</td>
                    <td>{{ item.deviceName }}</td>
                    <td>{{ item.status }}</td>
                    <td>{{ item.fac_point }}</td>
                    <td>{{ item.manufacturer }}</td>
                    <td>{{ item.factory_area }}</td>
                    <td>                     
                      <div class="table-action-btns" v-if="item.id">
                        <button class="search-btn-green" style="padding:4px 8px;" @click="showPointView(item)">
                          详情
                        </button>
                        <button class="search-btn-green" style="padding:4px 8px;" @click="showPointEdit(item)">
                          编辑
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="pagedPointList.length === 0">
                    <td colspan="8" style="text-align:center;color:#bbb;">暂无数据</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- 分页 -->
            <div class="pagination">
              <button class="page-btn" :disabled="pointPage===1" @click="changePointPage(1)">«</button>
              <button class="page-btn" :disabled="pointPage===1" @click="changePointPage(pointPage - 1)">‹</button>
              <span v-for="p in displayPointPages" :key="p">
                <button class="page-btn" :class="{active:pointPage===p}" @click="changePointPage(p)">{{p}}</button>
              </span>
              <button class="page-btn" :disabled="pointPage===pointTotalPages" @click="changePointPage(pointPage + 1)">›</button>
              <button class="page-btn" :disabled="pointPage===pointTotalPages" @click="changePointPage(pointTotalPages)">»</button>
              <div class="page-jump">
                <input type="text" v-model="pointPageInput" style="width:50px;" />
                <button class="jump-btn" @click="jumpPointPage">跳转</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="activeTab === '处理流程'">
        <!-- 处理流程新增弹窗 -->
        <div v-if="processViewMode === 'add'" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
          <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
              <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">新增违规信息</span>
              <button @click="closeProcessDetail" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
            </div>
            <div style="display:flex;flex-direction:column;gap:18px;">
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">违规编号：</span><input class="form-input" v-model="processCurrentItem.violationNumber" style="width:400px;" /></div>
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">设备编号：</span>
                <select v-model="processCurrentItem.deviceNumber" class="form-input" style="width:400px;">
                  <option value="">请选择</option>
                  <option value="100">100</option>
                  <option value="103">103</option>
                  <option value="105">105</option>
                  <option value="106">106</option>
                  <option value="107">107</option>
                </select>
              </div>
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">设备类型：</span><input class="form-input" v-model="processCurrentItem.deviceType" style="width:400px;" /></div>
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">安装位置：</span><input class="form-input" v-model="processCurrentItem.location" style="width:400px;" /></div>
              <!-- <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">车辆类型：</span><input class="form-input" v-model="processCurrentItem.vehicleType" style="width:400px;" /></div> -->
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">违规人：</span><input class="form-input" v-model="processCurrentItem.violationPerson" style="width:400px;" /></div>
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">车牌号：</span><input class="form-input" v-model="processCurrentItem.plateNumber" style="width:400px;" /></div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">违规时间：</span>
                <input class="form-input" type="datetime-local" v-model="processCurrentItem.violationTime" placeholder="选择违规时间" style="width:400px;" />
              </div>
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">处理状态：</span>
                <select v-model="processCurrentItem.status" class="form-input" style="width:400px;">
                  <option value="未解决">未解决</option>
                  <option value="已解决">已解决</option>
                </select>
              </div>
            </div>
            <div style="display:flex;justify-content:flex-end;gap:16px;margin-top:32px;">
              <button class="search-btn-green" @click="saveProcessAdd" style="min-width:80px;">保存</button>
              <button class="search-btn-green" @click="closeProcessDetail" style="background:#eee;color:#333;min-width:80px;">取消</button>
            </div>
          </div>
        </div>
        
        <!-- 处理流程详情弹窗 -->
        <div v-else-if="processViewMode === 'view'" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
          <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
              <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">处理流程详情</span>
              <button @click="closeProcessDetail" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
            </div>
            <div style="display:flex;flex-direction:column;gap:18px;">
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">违规编号：</span><input class="form-input" :value="processCurrentItem.violationNumber" style="width:400px;" readonly /></div>
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">设备编号：</span><input class="form-input" :value="processCurrentItem.deviceNumber" style="width:400px;" readonly /></div>
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">设备类型：</span><input class="form-input" :value="processCurrentItem.deviceType" style="width:400px;" readonly /></div>
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">安装位置：</span><input class="form-input" :value="processCurrentItem.location" style="width:400px;" readonly /></div>
              <!-- <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">车辆类型：</span><input class="form-input" :value="processCurrentItem.vehicleType" style="width:400px;" readonly /></div> -->
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">违规人：</span><input class="form-input" :value="processCurrentItem.violationPerson" style="width:400px;" readonly /></div>
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">车牌号：</span><input class="form-input" :value="processCurrentItem.plateNumber" style="width:400px;" readonly /></div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">违规时间：</span>
                <input class="form-input" :value="processCurrentItem.violationTime" style="width:400px;" readonly />
              </div>
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">处理状态：</span><input class="form-input" :value="processCurrentItem.status" style="width:400px;" readonly /></div>
            </div>
          </div>
        </div>
        <!-- 处理流程编辑弹窗 -->
        <div v-else-if="processViewMode === 'edit'" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
          <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
              <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">编辑处理流程</span>
              <button @click="closeProcessDetail" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
            </div>
            <div style="display:flex;flex-direction:column;gap:18px;">
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">违规人：</span><input class="form-input" v-model="processCurrentItem.violationPerson" style="width:400px;" /></div>
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">处理人：</span><input class="form-input" v-model="processCurrentItem.processPerson" style="width:400px;" /></div>
              <div style="display:flex;align-items:center;">
                <span style="width:120px;text-align:left;">处理时间：</span>
                <input class="form-input" type="datetime-local" v-model="processCurrentItem.processTime" placeholder="选择处理时间" style="width:400px;" />
              </div>
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">处理状态：</span>
                <select v-model="processCurrentItem.status" class="form-input" style="width:400px;">
                  <option value="未解决">未解决</option>
                  <option value="已解决">已解决</option>
                </select>
              </div>
              <div style="display:flex;align-items:center;"><span style="width:120px;text-align:left;">处理说明：</span><input class="form-input" v-model="processCurrentItem.processInstruction" style="width:400px;" /></div>
            </div>
            <div style="display:flex;justify-content:flex-end;gap:16px;margin-top:32px;">
              <button class="search-btn-green" @click="saveProcessEdit" style="min-width:80px;">保存</button>
              <button class="search-btn-green" @click="closeProcessDetail" style="background:#eee;color:#333;min-width:80px;">取消</button>
            </div>
          </div>
        </div>
        <!-- 处理流程列表视图 -->
        <div v-else-if="processViewMode === 'list'">
          <!-- 处理流程筛选表单 -->
          <div class="search-section search-section-new">
            <form class="search-form-2x2">
              <div class="form-fields">
                <!-- <div class="form-item">
                  <label>所属厂区：</label>
                  <select class="form-input" v-model="processQuery.park">
                    <option value="">泰山路</option>
                  </select>
                </div> -->
                <div class="form-item">
                  <label>车牌号：</label>
                  <input class="form-input" v-model="processQuery.plateNumber" placeholder="车牌号" />
                </div>
                <div class="form-item">
                  <label>安装位置：</label>
                  <select class="form-input" v-model="processQuery.location">
                    <option value="">全部</option>
                    <option value="东门南北方向">东门南北方向</option>
                    <option value="北门南北方向">北门南北方向</option>
                    <option value="C门东西方向">C门东西方向</option>
                    <option value="B门东西方向">B门东西方向</option>
                    <option value="A门东西方向">A门东西方向</option>
                  </select>
                </div>
                <div class="form-item">
                  <label>设备编号：</label>
                  <select class="form-input" v-model="processQuery.deviceNumber">
                    <option value="">全部</option>
                    <option value="100">100</option>
                    <option value="103">103</option>
                    <option value="105">105</option>
                    <option value="106">106</option>
                    <option value="107">107</option>
                  </select>
                </div>


                <div class="form-item">
                  <label>开始日期：</label>
                  <input class="form-input" type="date" v-model="processQuery.startDate" placeholder="选择开始日期" />
                </div>
                <div class="form-item">
                  <label>结束日期：</label>
                  <input class="form-input" type="date" v-model="processQuery.endDate" placeholder="选择结束日期" />
                </div>
              </div>
                            <div class="form-btns">
                <button type="button" class="search-btn-green" @click="searchProcess">
                  查询
                </button>
                <button type="button" class="search-btn-green" @click="printProcess">
                  打印
                </button>
              </div>
            </form>
          </div>
          
          <!-- 新增按钮 -->
          <!-- <div style="margin: 0 0 16px 8px;">
            <button class="search-btn-green" @click="addProcess" style="background:#4caf50;">
              <span style="font-size:18px;font-weight:bold;">＋</span> 新增违规
            </button>
          </div> -->
          
          <!-- 处理流程表格 -->
          <div class="data-section">
            <div class="table-container">
              <table class="data-table">
                <thead>
                  <tr>
                    <th>序号</th>
                    <th>违规编号</th>
                    <th>设备编号</th>
                    <th>设备类型</th>
                    <th>安装位置</th>
                    <th>违规人</th>
                    <th>车牌号</th>
                    <th>速度</th>
                    <th>违规时间</th>
                    <th>处理状态</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, idx) in pagedProcessList" :key="item.id">
                    <td>{{ (processPage-1)*processPageSize + idx + 1 }}</td>
                    <td>{{ item.violationNumber }}</td>
                    <td>{{ item.deviceNumber }}</td>
                    <td>{{ item.deviceType }}</td>
                    <td>{{ item.location }}</td>
                    <td>{{ item.violationPerson }}</td>
                    <td>{{ item.plateNumber }}</td>
                    <td>{{ item.speed }}</td>
                    <td>{{ item.violationTime }}</td>
                    <td>
                      <span v-if="item.status==='未解决'" style="color:#fff;background:#e74c3c;padding:2px 8px;border-radius:4px;font-size:13px;">未解决</span>
                      <span v-else style="color:#fff;background:#4caf50;padding:2px 8px;border-radius:4px;font-size:13px;">已解决</span>
                    </td>
                    <td>
                      <div class="table-action-btns">
                        <button class="search-btn-green" style="padding:4px 8px;" @click="showProcessView(item)">
                          详情
                        </button>
                        <button class="search-btn-green" style="padding:4px 8px;" @click="showProcessEdit(item)">
                          编辑
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="pagedProcessList.length === 0">
                    <td colspan="11" style="text-align:center;color:#bbb;">暂无数据</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- 分页 -->
            <div class="pagination">
              <button class="page-btn" :disabled="processPage===1" @click="changeProcessPage(1)">«</button>
              <button class="page-btn" :disabled="processPage===1" @click="changeProcessPage(processPage-1)">‹</button>
              <span v-for="p in displayProcessPages" :key="p">
                <button class="page-btn" :class="{active:processPage===p}" @click="changeProcessPage(p)">{{p}}</button>
              </span>
              <button class="page-btn" :disabled="processPage===processTotalPages" @click="changeProcessPage(processPage+1)">›</button>
              <button class="page-btn" :disabled="processPage===processTotalPages" @click="changeProcessPage(processTotalPages)">»</button>
              <div class="page-jump">
                <input type="text" v-model="processPageInput" style="width:50px;" />
                <button class="jump-btn" @click="jumpProcessPage">跳转</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="activeTab === '设备维修'">
        <!-- 设备维修新增弹窗 -->
        <div v-if="repairAddMode" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
          <div class="modal-content" style="background:#fff;padding:30px 40px;border-radius:8px;min-width:800px;max-width:900px;max-height:90vh;overflow-y:auto;position:relative;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:24px;">
              <span style="font-size:20px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">新增维修信息</span>
              <button @click="closeRepairAdd" style="background:none;border:none;font-size:24px;cursor:pointer;line-height:1;">×</button>
            </div>
            <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;">
              <!-- 左侧字段 -->
              <div style="display:flex;flex-direction:column;gap:16px;">
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">维修ID：</span><input class="form-input" :value="generateMaintenanceId()" style="width:100%;" readonly /></div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">设备编号：</span>
                  <select v-model="repairAddItem.deviceNumber" class="form-input" style="width:100%;">
                    <option value="">请选择</option>
                  <option value="100">100</option>
                  <option value="103">103</option>
                  <option value="105">105</option>
                  <option value="106">106</option>
                  <option value="107">107</option>
                </select>
              </div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">设备名称：</span><input class="form-input" v-model="repairAddItem.deviceName" style="width:100%;" placeholder="请输入设备名称" /></div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">安装类型：</span>
                  <select v-model="repairAddItem.installType" class="form-input" style="width:100%;">
                  <option value="摄像头">摄像头</option>
                  <option value="雷达">雷达</option>
                </select>
              </div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">安装位置：</span><input class="form-input" :value="deviceLocationMap[repairAddItem.deviceNumber] || ''" style="width:100%;" readonly /></div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">申报人：</span><input class="form-input" v-model="repairAddItem.reporter" style="width:100%;" placeholder="请输入申报人" /></div>
              <div style="display:flex;align-items:center;">
                  <span style="width:100px;text-align:left;font-size:14px;">申报时间：</span>
                  <input class="form-input" type="datetime-local" v-model="repairAddItem.reportTime" style="width:100%;" />
              </div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">故障说明：</span><input class="form-input" v-model="repairAddItem.faultDesc" style="width:100%;" placeholder="请输入故障说明" /></div>
              </div>
              
              <!-- 右侧字段 -->
              <div style="display:flex;flex-direction:column;gap:16px;">
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">解决状态：</span>
                  <select v-model="repairAddItem.solveStatus" class="form-input" style="width:100%;">
                  <option value="未解决">未解决</option>
                  <option value="已解决">已解决</option>
                </select>
              </div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">解决说明：</span><input class="form-input" v-model="repairAddItem.solveDesc" style="width:100%;" placeholder="请输入解决说明" /></div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">解决人：</span><input class="form-input" v-model="repairAddItem.solver" style="width:100%;" placeholder="请输入解决人" /></div>
              <div style="display:flex;align-items:center;">
                  <span style="width:100px;text-align:left;font-size:14px;">解决时间：</span>
                  <input class="form-input" type="datetime-local" v-model="repairAddItem.solveTime" style="width:100%;" />
              </div>
                
                <!-- 图片上传区域 -->
                <div style="display:flex;flex-direction:column;gap:12px;border:1px solid #ff0000;padding:8px;">
                  <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">故障图片：</span>
                    <div style="flex:1;">
                      <label style="cursor:pointer;display:block;">
                        <input type="file" accept="image/*" style="display:none;" @change="(e) => onRepairAddImageChange(e, 'fault')" />
                        <div v-if="!repairAddItem.faultImage" style="width:120px;height:80px;border:2px dashed #ddd;border-radius:8px;display:flex;flex-direction:column;align-items:center;justify-content:center;font-size:12px;color:#888;background:#fafbfc;transition:all 0.3s;">
                          <div style="font-size:20px;margin-bottom:4px;">+</div>
                          <div>点击上传</div>
            </div>
                        <img v-else :src="repairAddItem.faultImage" style="width:120px;height:80px;border-radius:8px;object-fit:cover;border:2px solid #ddd;cursor:pointer;" @click="previewImage(repairAddItem.faultImage)" />
                      </label>
                    </div>
                  </div>
                  
                  <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">解决图片：</span>
                    <div style="flex:1;">
                      <label style="cursor:pointer;display:block;">
                        <input type="file" accept="image/*" style="display:none;" @change="(e) => onRepairAddImageChange(e, 'solve')" />
                        <div v-if="!repairAddItem.solveImage" style="width:120px;height:80px;border:2px dashed #ddd;border-radius:8px;display:flex;flex-direction:column;align-items:center;justify-content:center;font-size:12px;color:#888;background:#fafbfc;transition:all 0.3s;">
                          <div style="font-size:20px;margin-bottom:4px;">+</div>
                          <div>点击上传</div>
                        </div>
                        <img v-else :src="repairAddItem.solveImage" style="width:120px;height:80px;border-radius:8px;object-fit:cover;border:2px solid #ddd;cursor:pointer;" @click="previewImage(repairAddItem.solveImage)" />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="display:flex;justify-content:flex-end;gap:16px;margin-top:24px;border-top:1px solid #eee;padding-top:20px;">
              <button class="search-btn-green" @click="saveRepairAdd" style="min-width:80px;">保存</button>
              <button class="search-btn-green" @click="closeRepairAdd" style="background:#eee;color:#333;min-width:80px;">取消</button>
            </div>
          </div>
        </div>
        
        <!-- 设备维修详情弹窗 -->
        <div v-if="repairViewMode === 'view'" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
          <div class="modal-content" style="background:#fff;padding:30px 40px;border-radius:8px;min-width:800px;max-width:900px;max-height:90vh;overflow-y:auto;position:relative;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:24px;">
              <span style="font-size:20px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">设备维修详情</span>
              <button @click="closeRepairDetail" style="background:none;border:none;font-size:24px;cursor:pointer;line-height:1;">×</button>
            </div>
            <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;">
              <!-- 左侧字段 -->
              <div style="display:flex;flex-direction:column;gap:16px;">
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">维修ID：</span><input class="form-input" :value="repairCurrentItem.maintenance_id" style="width:100%;" readonly /></div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">设备编号：</span><input class="form-input" :value="repairCurrentItem.deviceNumber" style="width:100%;" readonly /></div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">设备名称：</span><input class="form-input" :value="repairCurrentItem.deviceName" style="width:100%;" readonly /></div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">安装类型：</span><input class="form-input" :value="repairCurrentItem.installType" style="width:100%;" readonly /></div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">安装位置：</span><input class="form-input" :value="repairCurrentItem.installLocation" style="width:100%;" readonly /></div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">申报人：</span><input class="form-input" :value="repairCurrentItem.reporter" style="width:100%;" readonly /></div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">申报时间：</span><input class="form-input" :value="repairCurrentItem.reportTime" style="width:100%;" readonly /></div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">故障说明：</span><input class="form-input" :value="repairCurrentItem.faultDesc" style="width:100%;" readonly /></div>
            </div>
              
              <!-- 右侧字段 -->
              <div style="display:flex;flex-direction:column;gap:16px;">
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">解决状态：</span><input class="form-input" :value="repairCurrentItem.solveStatus" style="width:100%;" readonly /></div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">解决说明：</span><input class="form-input" :value="repairCurrentItem.solveDesc" style="width:100%;" readonly /></div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">解决人：</span><input class="form-input" :value="repairCurrentItem.solver" style="width:100%;" readonly /></div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">解决时间：</span><input class="form-input" :value="repairCurrentItem.solveTime" style="width:100%;" readonly /></div>
                
                <!-- 图片显示区域 -->
                <div style="display:flex;flex-direction:column;gap:12px;">
                  <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">故障图片：</span>
                    <div style="flex:1;">
                      <img v-if="repairCurrentItem.faultImage" :src="repairCurrentItem.faultImage" style="width:120px;height:80px;border-radius:8px;object-fit:cover;border:2px solid #ddd;cursor:pointer;" @click="previewImage(repairCurrentItem.faultImage)" />
                      <div v-else style="width:120px;height:80px;border:2px dashed #ddd;border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:12px;color:#999;background:#fafbfc;">无图片</div>
          </div>
        </div>
                  
                  <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">解决图片：</span>
                    <div style="flex:1;">
                      <img v-if="repairCurrentItem.solveImage" :src="repairCurrentItem.solveImage" style="width:120px;height:80px;border-radius:8px;object-fit:cover;border:2px solid #ddd;cursor:pointer;" @click="previewImage(repairCurrentItem.solveImage)" />
                      <div v-else style="width:120px;height:80px;border:2px dashed #ddd;border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:12px;color:#999;background:#fafbfc;">无图片</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 设备维修编辑弹窗 -->
        <div v-else-if="repairViewMode === 'edit'" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
          <div class="modal-content" style="background:#fff;padding:30px 40px;border-radius:8px;min-width:800px;max-width:900px;max-height:90vh;overflow-y:auto;position:relative;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:24px;">
              <span style="font-size:20px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">编辑设备维修</span>
              <button @click="closeRepairDetail" style="background:none;border:none;font-size:24px;cursor:pointer;line-height:1;">×</button>
            </div>
            <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;">
              <!-- 左侧字段 -->
              <div style="display:flex;flex-direction:column;gap:16px;">
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">维修ID：</span><input class="form-input" :value="repairCurrentItem.maintenance_id" style="width:100%;" readonly /></div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">设备编号：</span>
                  <select v-model="repairCurrentItem.deviceNumber" class="form-input" style="width:100%;">
                  <option value="100">100</option>
                  <option value="103">103</option>
                  <option value="105">105</option>
                  <option value="106">106</option>
                  <option value="107">107</option>
                </select>
              </div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">设备名称：</span><input class="form-input" v-model="repairCurrentItem.deviceName" style="width:100%;" /></div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">安装类型：</span>
                  <select v-model="repairCurrentItem.installType" class="form-input" style="width:100%;">
                  <option value="摄像头">摄像头</option>
                  <option value="雷达">雷达</option>
                </select>
              </div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">安装位置：</span><input class="form-input" :value="deviceLocationMap[repairCurrentItem.deviceNumber] || ''" style="width:100%;" readonly /></div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">申报人：</span><input class="form-input" v-model="repairCurrentItem.reporter" style="width:100%;" /></div>
              <div style="display:flex;align-items:center;">
                  <span style="width:100px;text-align:left;font-size:14px;">申报时间：</span>
                  <input class="form-input" type="datetime-local" v-model="repairCurrentItem.reportTime" style="width:100%;" />
              </div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">故障说明：</span><input class="form-input" v-model="repairCurrentItem.faultDesc" style="width:100%;" /></div>
              </div>
              
              <!-- 右侧字段 -->
              <div style="display:flex;flex-direction:column;gap:16px;">
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">解决状态：</span>
                  <select v-model="repairCurrentItem.solveStatus" class="form-input" style="width:100%;">
                  <option value="未解决">未解决</option>
                  <option value="已解决">已解决</option>
                </select>
              </div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">解决说明：</span><input class="form-input" v-model="repairCurrentItem.solveDesc" style="width:100%;" /></div>
                <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">解决人：</span><input class="form-input" v-model="repairCurrentItem.solver" style="width:100%;" /></div>
              <div style="display:flex;align-items:center;">
                  <span style="width:100px;text-align:left;font-size:14px;">解决时间：</span>
                  <input class="form-input" type="datetime-local" v-model="repairCurrentItem.solveTime" style="width:100%;" />
              </div>
                
                <!-- 图片上传区域 -->
                <div style="display:flex;flex-direction:column;gap:12px;">
                  <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">故障图片：</span>
                    <div style="flex:1;">
                      <label style="cursor:pointer;display:block;">
                        <input type="file" accept="image/*" style="display:none;" @change="(e) => onRepairDetailImageChange(e, 'fault')" />
                        <div v-if="!repairCurrentItem.faultImage" style="width:120px;height:80px;border:2px dashed #ddd;border-radius:8px;display:flex;flex-direction:column;align-items:center;justify-content:center;font-size:12px;color:#888;background:#fafbfc;transition:all 0.3s;">
                          <div style="font-size:20px;margin-bottom:4px;">+</div>
                          <div>点击上传</div>
            </div>
                        <img v-else :src="repairCurrentItem.faultImage" style="width:120px;height:80px;border-radius:8px;object-fit:cover;border:2px solid #ddd;cursor:pointer;" @click="previewImage(repairCurrentItem.faultImage)" />
                      </label>
                    </div>
                  </div>
                  
                  <div style="display:flex;align-items:center;"><span style="width:100px;text-align:left;font-size:14px;">解决图片：</span>
                    <div style="flex:1;">
                      <label style="cursor:pointer;display:block;">
                        <input type="file" accept="image/*" style="display:none;" @change="(e) => onRepairDetailImageChange(e, 'solve')" />
                        <div v-if="!repairCurrentItem.solveImage" style="width:120px;height:80px;border:2px dashed #ddd;border-radius:8px;display:flex;flex-direction:column;align-items:center;justify-content:center;font-size:12px;color:#888;background:#fafbfc;transition:all 0.3s;">
                          <div style="font-size:20px;margin-bottom:4px;">+</div>
                          <div>点击上传</div>
                        </div>
                        <img v-else :src="repairCurrentItem.solveImage" style="width:120px;height:80px;border-radius:8px;object-fit:cover;border:2px solid #ddd;cursor:pointer;" @click="previewImage(repairCurrentItem.solveImage)" />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="display:flex;justify-content:flex-end;gap:16px;margin-top:24px;border-top:1px solid #eee;padding-top:20px;">
              <button class="search-btn-green" @click="saveRepairEdit" style="min-width:80px;">保存</button>
              <button class="search-btn-green" @click="closeRepairDetail" style="background:#eee;color:#333;min-width:80px;">取消</button>
            </div>
          </div>
        </div>
        <!-- 设备维修列表视图 -->
        <div v-else-if="repairViewMode === 'list'">
          <!-- 设备维修列表视图 -->
          <div class="search-section search-section-new">
            <form class="search-form-2x2">
              <div class="form-fields">
                <div class="form-item">
                  <label>开始日期：</label>
                  <input class="form-input" type="date" v-model="repairQuery.startDate" placeholder="选择开始日期" />
                </div>
                <div class="form-item">
                  <label>结束日期：</label>
                  <input class="form-input" type="date" v-model="repairQuery.endDate" placeholder="选择结束日期" />
                </div>
                <div class="form-item">
                  <label>设备编号：</label>
                  <select class="form-input" v-model="repairQuery.deviceNumber">
                    <option value="">全部</option>
                    <option value="100">100</option>
                    <option value="103">103</option>
                    <option value="105">105</option>
                    <option value="106">106</option>
                    <option value="107">107</option>
                  </select>
                </div>
                <!-- <div class="form-item">
                  <label>设备类型：</label>
                  <select class="form-input" v-model="repairQuery.deviceType">
                    <option value="">全部</option>
                    <option value="摄像头">摄像头</option>
                    <option value="雷达">雷达</option>
                  </select>
                </div> -->
                <div class="form-item">
                  <label>解决状态：</label>
                  <select class="form-input" v-model="repairQuery.resolutionState">
                    <option value="">全部</option>
                    <option value="未解决">未解决</option>
                    <option value="已解决">已解决</option>
                  </select>
                </div>
              </div>
              <div class="form-btns">
                <button type="button" class="search-btn-green" @click="searchRepair">
                  查询
                </button>
                <button type="button" class="search-btn-green" @click="printRepair">
                  打印
                </button>
              </div>
            </form>
          </div>
          <!-- 新增按钮 -->
          <div style="margin: 0 0 16px 8px;">
            <button class="search-btn-green" @click="addRepair" style="background:#4caf50;">
              <span style="font-size:18px;font-weight:bold;">＋</span> 添加
            </button>
          </div>
          <!-- 设备维修表格 -->
          <div class="data-section">
            <div class="table-container">
              <table class="data-table">
                <thead>
                  <tr>
                    <th>序号</th>
                    <th>维修ID</th>
                    <th>设备编号</th>
                    <th>设备名称</th>
                    <th>安装类型</th>
                    <th>安装位置</th>
                    <th>申报人</th>
                    <th>申报时间</th>
                    <th>故障说明</th>
                    <th>故障图片</th>
                    <th>解决状态</th>
                    <th>解决说明</th>
                    <th>解决图片</th>
                    <th>解决人</th>
                    <th>解决时间</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, idx) in pagedRepairList" :key="item.id">
                    <td>{{ (repairPage-1)*repairPageSize + idx + 1 }}</td>
                    <td>{{ item.maintenance_id }}</td>
                    <td>{{ item.deviceNumber }}</td>
                    <td>{{ item.deviceName }}</td>
                    <td>{{ item.installType }}</td>
                    <td>{{ item.installLocation }}</td>
                    <td>{{ item.reporter }}</td>
                    <td>{{ item.reportTime }}</td>
                    <td>{{ item.faultDesc }}</td>
                    <td>
                      <img v-if="item.faultImage" :src="item.faultImage" style="width:40px;height:30px;border-radius:4px;object-fit:cover;cursor:pointer;" @click="previewImage(item.faultImage)" />
                      <span v-else style="color:#999;font-size:12px;">无图片</span>
                    </td>
                    <td>
                      <span v-if="item.solveStatus==='未解决'" style="color:#fff;background:#e74c3c;padding:2px 8px;border-radius:4px;font-size:13px;">未解决</span>
                      <span v-else style="color:#fff;background:#4caf50;padding:2px 8px;border-radius:4px;font-size:13px;">已解决</span>
                    </td>
                    <td>{{ item.solveDesc }}</td>
                    <td>
                      <img v-if="item.solveImage" :src="item.solveImage" style="width:40px;height:30px;border-radius:4px;object-fit:cover;cursor:pointer;" @click="previewImage(item.solveImage)" />
                      <span v-else style="color:#999;font-size:12px;">无图片</span>
                    </td>
                    <td>{{ item.solver }}</td>
                    <td>{{ item.solveTime }}</td>
                    <td>
                      <div class="table-action-btns" >
                        <button class="search-btn-green" style="padding:4px 8px;" @click="showRepairView(item)">
                          详情
                        </button>
                        <button class="search-btn-green" style="padding:4px 8px;" @click="showRepairEdit(item)">
                          编辑
                        </button>
                        <!-- <button class="search-btn-green" style="padding:4px 8px;background:#e74c3c;" @click="deleteRepair(item)">
                          删除
                        </button> -->
                      </div>
                    </td>
                  </tr>
                  <tr v-if="pagedRepairList.length === 0">
                    <td colspan="17" style="text-align:center;color:#bbb;">暂无数据</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- 分页 -->
            <div class="pagination">
              <button class="page-btn" :disabled="repairPage===1" @click="changeRepairPage(1)">«</button>
              <button class="page-btn" :disabled="repairPage===1" @click="changeRepairPage(repairPage - 1)">‹</button>
              <span v-for="p in displayRepairPages" :key="p">
                <button class="page-btn" :class="{active:repairPage===p}" @click="changeRepairPage(p)">{{p}}</button>
              </span>
              <button class="page-btn" :disabled="repairPage===repairTotalPages" @click="changeRepairPage(repairPage + 1)">›</button>
              <button class="page-btn" :disabled="repairPage===repairTotalPages" @click="changeRepairPage(repairTotalPages)">»</button>
              <div class="page-jump">
                <input type="text" v-model="repairPageInput" style="width:50px;" />
                <button class="jump-btn" @click="jumpRepairPage">跳转</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 大图预览弹窗 -->
      <div v-if="showImagePreview" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#000a;z-index:2000;display:flex;align-items:center;justify-content:center;">
        <div @click.self="closeImagePreview" style="position:fixed;left:0;top:0;width:100vw;height:100vh;"></div>
        <div style="position:relative;z-index:1;">
          <img :src="previewImageUrl" style="max-width:80vw;max-height:80vh;border-radius:8px;box-shadow:0 2px 16px #0008;" />
          <button @click="closeImagePreview" style="position:absolute;top:-32px;right:0;background:none;border:none;font-size:32px;color:#fff;cursor:pointer;">×</button>
        </div>
      </div>
  </div>
</template>
<script>
import { createPointMessage, queryPointMessage, queryViolations, createViolation, createMaintenance, queryMaintenance } from '@/api/traffic.js';

export default {
  name: 'AiTraffic',
  data() {
    return {
      currentImage: '', // 当前显示的图片
      selectedAlarm: null, // 当前选中的告警信息
      alarmList: [],
      activeTab: '实时告警',
      tabs: [
        { label: '实时告警' },
        { label: '历史查询' },
        { label: '点位管理' },
        { label: '处理流程' },
        { label: '设备维修' }
      ],
      // 历史查询相关
      historyQuery: {
        park: '',
        plateNumber: '',
        location: '',
        deviceNumber: '',
        startDate: '',
        endDate: '',
        speedMin: 30, // 固定最小车速为30
        speedMax: 200 // 最大车速
      },
      historyList: [

      ],
      historyPage: 1,
      historyPageSize: 10,
      historyPageInput: '1',
      historyTotalPagesState: 1, // 添加总页数状态
      historyViewMode: 'list', // 'list' | 'view' | 'edit'
      historyCurrentItem: null,
      // 点位管理相关
      pointQuery: {
        deviceNumber: '',
        park: '',
        location: '',
        startDate: '',
        endDate: ''
      },
      pointList: [],
      pointPage: 1,
      pointPageSize: 10,
      pointPageInput: '1',
      pointTotalPagesState: 1,
      pointAddMode: false,
      pointAddItem: {
        fac_id: '',
        fac_name: '',
        fac_model: '摄像头',
        fac_state: '在线',
        fac_point: '',
        detail_location: '',
        factory_area: '',
        manufacturer: '',
        install_instruction: '',
        install_date: '',
        install_photo: '',
        applicant: ''
      },
      // 添加点位管理详情和编辑模式
      pointViewMode: 'list', // 'list' | 'view' | 'edit'
      pointCurrentItem: null,
      // 处理流程相关
      processQuery: {
        park: '',
        plateNumber: '',
        location: '',
        deviceNumber: '',
        vehicleType: '',
        startDate: '',
        endDate: ''
      },
      processList: [],
      processPage: 1,
      processPageSize: 10,
      processPageInput: '1',
      processTotalPagesState: 1, // 添加总页数状态
      // 添加处理流程详情和编辑模式
      processViewMode: 'list', // 'list' | 'view' | 'edit'
      processCurrentItem: {
        // ... existing fields ...
        processPerson: '',
        processTime: '',
        processInstruction: ''
      },
      // 设备维修相关
      repairQuery: {
        startDate: '',
        endDate: '',
        deviceNumber: '',
        deviceType: '',
        resolutionState: ''
      },
      repairList: [
        
      ],
      repairPage: 1,
      repairPageSize: 10,
      repairPageInput: '1',
      repairTotalPagesState: 1,
      // 添加设备维修详情和编辑模式
      repairViewMode: 'list', // 'list' | 'view' | 'edit'
      repairCurrentItem: null,
      // 实时告警相关
      alarmQuery: {
        type: '超速告警',
        park: '',
        deviceNumber: '',
        location: ''
      },
      alarmPage: 1,
      alarmPageSize: 10,
      alarmPageInput: '1',
      alarmTotalPagesState: 1, // 添加总页数状态
      // 添加设备维修新增模式
      repairAddMode: false,
      repairAddItem: {
        maintenance_id: '',
        deviceNumber: '',
        deviceName: '',
        installType: '摄像头',
        installLocation: '',
        reporter: '',
        reportTime: '',
        faultImage: null,
        faultDesc: '',
        solveStatus: '未解决',
        solveDesc: '',
        solveImage: null,
        solver: '',
        solveTime: ''
      },
      pointDetailMode: '', // 'view' | 'edit'
      pointDetailItem: null,
      showImagePreview: false,
      previewImageUrl: '',
      pointFieldLabels: {
        fac_id: '设备编号',
        fac_model: '设备类型',
        fac_name: '设备名称',
        fac_state: '设备状态',
        fac_point: '设备点位信息',
        detail_location: '详细位置',
        factory_area: '所属厂区',
        manufacturer: '生产厂家',
        install_instruction: '安装说明',
        install_date: '安装日期',
        applicant: '申报人',
      },
      // 添加设备编号和安装位置的映射关系
      deviceLocationMap: {
        '100': '东门南北方向',
        '103': '北门南北方向',
        '105': 'C门东西方向',
        '106': 'B门东西方向',
        '107': 'A门东西方向'
      },
      // 添加安装位置到设备编号的反向映射
      locationDeviceMap: {
        '东门南北方向': '100',
        '北门南北方向': '103',
        'C门东西方向': '105',
        'B门东西方向': '106',
        'A门东西方向': '107'
      },
      // 设备编号与channel字段的映射关系
      deviceChannelMap: {
        '': '', // 全部对应空值
        '100': '1',
        '103': '0', 
        '105': '2',
        '106': '3',
        '107': '4'
      },
      // 添加channel到设备编号的反向映射
      channelDeviceMap: {
        '0': '103',
        '1': '100',
        '2': '105',
        '3': '106',
        '4': '107'
      },
    }
  },
  computed: {
    pagedHistoryList() {
      // 无论是否使用API分页，都需要在前端进行分页显示
      // 因为API分页只是获取数据，前端还需要控制每页显示的数量
      
      console.log('=== 历史查询分页计算开始 ===');
      console.log('this.historyList:', this.historyList);
      console.log('this.historyList.length:', this.historyList ? this.historyList.length : 'undefined');
      console.log('this.historyPage:', this.historyPage);
      console.log('this.historyPageSize:', this.historyPageSize);
      
      // 安全检查：确保数据列表存在且页码有效
      if (!this.historyList || this.historyList.length === 0) {
        console.log('=== 历史查询分页计算 ===');
        console.log('数据列表为空，返回空数组');
        console.log('this.historyList 类型:', typeof this.historyList);
        console.log('this.historyList 值:', this.historyList);
        return [];
      }
      
      // 如果使用API分页，直接返回整个列表
      if (this.historyTotalPagesState && this.historyTotalPagesState > 0) {
        console.log('使用API分页，返回完整列表');
        return this.historyList;
      }
      
      // 否则使用前端分页
      const start = (this.historyPage-1)*this.historyPageSize;
      const end = start + this.historyPageSize;
      const result = this.historyList.slice(start, end);
      
      console.log('=== 历史查询分页计算 ===');
      console.log('当前页码:', this.historyPage);
      console.log('每页数量:', this.historyPageSize);
      console.log('总数据量:', this.historyList.length);
      console.log('分页起始索引:', start);
      console.log('分页结束索引:', end);
      console.log('分页后数据量:', result.length);
      console.log('分页结果:', result);
      console.log('=== 历史查询分页计算结束 ===');
      
      return result;
    },
    historyTotalPages() {
      // 如果API返回了总页数信息，使用API的数据；否则根据当前列表长度计算
      console.log('=== 计算历史查询总页数开始 ===');
      console.log('this.historyTotalPagesState:', this.historyTotalPagesState);
      console.log('this.historyList:', this.historyList);
      console.log('this.historyList.length:', this.historyList ? this.historyList.length : 'undefined');
      console.log('this.historyPageSize:', this.historyPageSize);
      
      if (this.historyTotalPagesState && this.historyTotalPagesState > 0) {
        console.log('使用API返回的总页数:', this.historyTotalPagesState);
        console.log('=== 计算历史查询总页数结束 ===');
        return this.historyTotalPagesState;
      }
      
      const calculatedPages = Math.max(1, Math.ceil((this.historyList ? this.historyList.length : 0) / this.historyPageSize));
      console.log('根据列表长度计算的总页数:', calculatedPages);
      console.log('=== 计算历史查询总页数结束 ===');
      return calculatedPages;
    },
    pagedPointList() {
      // 点位管理使用API分页，直接返回完整列表
      console.log('=== 点位管理分页计算 ===');
      console.log('使用API分页，返回完整列表');
      console.log('this.pointList:', this.pointList);
      console.log('this.pointList.length:', this.pointList ? this.pointList.length : 'undefined');
      return this.pointList || [];
    },
    pointTotalPages() {
      return this.pointTotalPagesState || 1;
    },
    pagedProcessList() {
      // 处理流程使用API分页，直接返回完整列表
      console.log('=== 处理流程分页计算 ===');
      console.log('使用API分页，返回完整列表');
      console.log('this.processList:', this.processList);
      console.log('this.processList.length:', this.processList ? this.processList.length : 'undefined');
      return this.processList || [];
    },
    processTotalPages() {
      // 处理流程使用API返回的总页数，如果没有则计算
      console.log('=== 计算处理流程总页数 ===');
      if (this.processTotalPagesState && this.processTotalPagesState > 0) {
        console.log('使用API返回的总页数:', this.processTotalPagesState);
        return this.processTotalPagesState;
      }
      const calculatedPages = Math.max(1, Math.ceil((this.processList ? this.processList.length : 0) / this.processPageSize));
      console.log('根据列表长度计算的总页数:', calculatedPages);
      return calculatedPages;
    },
    pagedRepairList() {
      // 设备维修使用API分页，直接返回完整列表
      console.log('=== 设备维修分页计算 ===');
      console.log('使用API分页，返回完整列表');
      console.log('this.repairList:', this.repairList);
      console.log('this.repairList.length:', this.repairList ? this.repairList.length : 'undefined');
      return this.repairList || [];
    },
    repairTotalPages() {
      // 设备维修使用API返回的总页数
      console.log('=== 计算设备维修总页数 ===');
      console.log('使用API返回的总页数:', this.repairTotalPagesState);
      return this.repairTotalPagesState || 1;
    },
    pagedAlarmList() {
      // 实时告警使用API分页，直接返回完整列表
      console.log('=== 实时告警分页计算 ===');
      console.log('使用API分页，返回完整列表');
      console.log('this.alarmList:', this.alarmList);
      console.log('this.alarmList.length:', this.alarmList ? this.alarmList.length : 'undefined');
      return this.alarmList || [];
    },
    alarmTotalPages() {
      // 实时告警使用API返回的总页数，如果没有则计算
      console.log('=== 计算实时告警总页数 ===');
      if (this.alarmTotalPagesState && this.alarmTotalPagesState > 0) {
        console.log('使用API返回的总页数:', this.alarmTotalPagesState);
        return this.alarmTotalPagesState;
      }
      const calculatedPages = Math.max(1, Math.ceil((this.alarmList ? this.alarmList.length : 0) / this.alarmPageSize));
      console.log('根据列表长度计算的总页数:', calculatedPages);
      return calculatedPages;
    },
    pointDetailFields() {
      if (!this.pointDetailItem) return {};
      // 只显示中文字段，过滤掉英文字段
      const omitKeys = ['install_photo_url', 'install_photo', 'deviceNumber', 'deviceName', 'deviceType', 'status', 'location'];
      return Object.fromEntries(
        Object.entries(this.pointDetailItem).filter(([key]) => !omitKeys.includes(key))
      );
    },
    // 新增：生成显示的页码范围，最多显示10页
    displayAlarmPages() {
      const total = this.alarmTotalPages;
      const current = this.alarmPage;
      const maxDisplay = 10;
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(maxDisplay / 2));
      let end = Math.min(total, start + maxDisplay - 1);
      
      if (end - start + 1 < maxDisplay) {
        start = Math.max(1, end - maxDisplay + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
    
    displayHistoryPages() {
      const total = this.historyTotalPages;
      const current = this.historyPage;
      const maxDisplay = 10;
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(maxDisplay / 2));
      let end = Math.min(total, start + maxDisplay - 1);
      
      if (end - start + 1 < maxDisplay) {
        start = Math.max(1, end - maxDisplay + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
    
    displayPointPages() {
      const total = this.pointTotalPages;
      const current = this.pointPage;
      const maxDisplay = 10;
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(maxDisplay / 2));
      let end = Math.min(total, start + maxDisplay - 1);
      
      if (end - start + 1 < maxDisplay) {
        start = Math.max(1, end - maxDisplay + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
    
    displayProcessPages() {
      const total = this.processTotalPages;
      const current = this.processPage;
      const maxDisplay = 10;
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(maxDisplay / 2));
      let end = Math.min(total, start + maxDisplay - 1);
      
      if (end - start + 1 < maxDisplay) {
        start = Math.max(1, end - maxDisplay + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
    
    displayRepairPages() {
      const total = this.repairTotalPages;
      const current = this.repairPage;
      const maxDisplay = 10;
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(maxDisplay / 2));
      let end = Math.min(total, start + maxDisplay - 1);
      
      if (end - start + 1 < maxDisplay) {
        start = Math.max(1, end - maxDisplay + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
  },
  mounted() {
    const BeijingTime2 = new Date(new Date() + 8 * 3600 * 1000);
    const year = BeijingTime2.getFullYear()
    this.historyQuery.startDate = year + "-01-01"
    this.processQuery.startDate = year + "-01-01"
    this.repairQuery.startDate = year + "-01-01"
    this.historyQuery.endDate = BeijingTime2.toISOString().slice(0, 10);
    this.processQuery.endDate = this.historyQuery.endDate
    this.repairQuery.endDate = this.historyQuery.endDate
  },
  created() {
    this.searchPoint();
    // 如果默认是实时告警页面，则自动查询
    if (this.activeTab === '实时告警') {
      this.searchAlarm();
    }
    // 初始化处理流程数据
    this.searchProcess();
    // 初始化设备维修数据
    this.searchRepair();
    // 初始化历史查询数据
    this.searchHistory();
  },
  watch: {

    // 历史查询联动
    'historyQuery.deviceNumber'(newVal) {
      if (newVal) {
        this.historyQuery.location = this.deviceLocationMap[newVal] || '';
      } else {
        this.historyQuery.location = '';
      }
    },
    'historyQuery.location'(newVal) {
      if (newVal) {
        this.historyQuery.deviceNumber = this.locationDeviceMap[newVal] || '';
      } else {
        this.historyQuery.deviceNumber = '';
      }
    },
    // 点位管理联动
    'pointQuery.deviceNumber'(newVal) {
      if (newVal) {
        this.pointQuery.location = this.deviceLocationMap[newVal] || '';
      } else {
        this.pointQuery.location = '';
      }
    },
    'pointQuery.location'(newVal) {
      if (newVal) {
        this.pointQuery.deviceNumber = this.locationDeviceMap[newVal] || '';
      } else {
        this.pointQuery.deviceNumber = '';
      }
    },
    // 实时告警联动
    'alarmQuery.deviceNumber'(newVal) {
      if (newVal) {
        this.alarmQuery.location = this.deviceLocationMap[newVal] || '';
      } else {
        this.alarmQuery.location = '';
      }
    },
    'alarmQuery.location'(newVal) {
      if (newVal) {
        this.alarmQuery.deviceNumber = this.locationDeviceMap[newVal] || '';
      } else {
        this.alarmQuery.deviceNumber = '';
      }
    },
    // 处理流程联动
    'processQuery.deviceNumber'(newVal) {
      if (newVal) {
        this.processQuery.location = this.deviceLocationMap[newVal] || '';
      } else {
        this.processQuery.location = '';
      }
    },
    'processQuery.location'(newVal) {
      if (newVal) {
        this.processQuery.deviceNumber = this.locationDeviceMap[newVal] || '';
      } else {
        this.processQuery.deviceNumber = '';
      }
    },
    // 设备维修联动
    'repairQuery.deviceNumber'(newVal) {
      if (newVal) {
        // 设备维修暂时不联动安装位置，因为安装位置是手动输入的
      }
    },
    // 新增设备维修联动
    'repairAddItem.deviceNumber'(newVal) {
      if (newVal) {
        this.repairAddItem.installLocation = this.deviceLocationMap[newVal] || '';
      }
    },
    // 编辑设备维修联动
    'repairCurrentItem.deviceNumber'(newVal) {
      if (newVal) {
        this.repairCurrentItem.installLocation = this.deviceLocationMap[newVal] || '';
      }
    },
    // 处理流程新增和编辑联动
    'processCurrentItem.deviceNumber'(newVal) {
      if (newVal) {
        this.processCurrentItem.location = this.deviceLocationMap[newVal] || '';
      }
    }
  },
  methods: {

    processImageUrl(url) {
      if (!url) return url;
      const matches = url.match('/media.*')
      console.log(matches[0])
      let result = null
      if(matches.length > 0) result = 'https://gdykpt.cn' + matches[0]
      console.log(result)
      return result;
    },
    // 新增：转换图片URL格式的方法
    convertImageUrl(url) {
      if (!url) return url;
      
      // 将 http://47.93.132.27:6011/pic?F5A4FFEA6B52A0433AF7A45DD80286FB 格式
      // 转换为 https://gdykpt.cn/pic/F5A4FFEA6B52A0433AF7A45DD80286FB 格式
      if (url.includes('http://47.93.132.27:6011/pic?')) {
        const imageId = url.split('?')[1];
        return `https://gdykpt.cn/pic/${imageId}`;
      }
      
      return url;
    },
    async queryPointMessage() {
      try {
        const params = {
          ...this.pointQuery,
          page: this.pointPage,
          per_page: this.pointPageSize,
        };
        
        // 打印请求参数用于调试
        console.log('=== 点位管理接口调用调试信息 ===');
        console.log('请求参数:', params);
        console.log('请求URL:', 'queryPointMessage API');
        console.log('请求方法:', 'POST/GET');
        console.log('========================');
        
        const response = await queryPointMessage(params);
        
        // 打印响应信息用于调试
        console.log('=== 点位管理接口响应调试信息 ===');
        console.log('响应状态:', response.status);
        console.log('响应数据:', response.data);
        console.log('========================');
        
        this.pointList = response.data.data.map(item => ({
          id: item.fac_id,
          deviceNumber: item.fac_id,
          deviceName: item.fac_name,
          status: item.fac_state,
          location: item.fac_point,
          manufacturer: item.manufacturer,
          company: '', // 接口未提供
          factory_area: item.factory_area,
        }));
        this.pointTotalPagesState = response.data.total_pages;
      } catch (error) {
        console.error("获取点位列表失败", error);
      }
    },
    selectAlarm(alarm) {
      this.selectedAlarm = alarm;
      
      // 如果有图片URL，直接显示
      if (alarm.imageUrl) {
        this.currentImage = alarm.imageUrl;
      } else if (alarm.imageData) {
        // 如果没有图片URL但有图片数据，尝试获取图片
        this.currentImage = ''; // 先清空，避免显示旧图片
        
        // 显示加载状态
        this.currentImage = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjE1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjVmNWY1Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPuaaguaXoOaXoOaEjzwvdGV4dD48L3N2Zz4=';
        
        // 新的数据格式中，图片URL直接存储在violation_photo字段中
        if (alarm.imageData.violation_photo) {
          // 转换图片URL格式并直接使用violation_photo作为图片URL
          alarm.imageUrl = this.convertImageUrl(alarm.imageData.violation_photo);
          this.currentImage = alarm.imageUrl;
          console.log('实时告警图片加载成功，使用violation_photo:', alarm.imageUrl);
        } else {
          // 如果没有violation_photo，尝试使用旧的getCaptureImage方法
        this.getCaptureImage(alarm.imageData, alarm.originalCaptureTime || alarm.updateTime)
          .then(imageUrl => {
            if (imageUrl) {
              alarm.imageUrl = imageUrl;
              this.currentImage = imageUrl;
            } else {
              // 如果获取失败，显示默认图片
              this.currentImage = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjE1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjVmNWY1Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPuaaguaXoOaXoOaEjzwvdGV4dD48L3N2Zz4=';
            }
          })
          .catch(error => {
            console.error('获取告警图片失败:', error);
            // 显示默认图片或错误提示
            this.currentImage = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjE1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjVmNWY1Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPuaaguaXoOaXoOaEjzwvdGV4dD48L3N2Zz4=';
          });
        }
      } else {
        // 既没有图片URL也没有图片数据，显示默认图片
        this.currentImage = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjE1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjVmNWY1Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPuaaguaXoOaXoOaEjzwvdGV4dD48L3N2Zz4=';
      }
    },
    switchTab(tab) {
      // 先重置所有视图状态
      this.historyViewMode = 'list';
      this.historyCurrentItem = null;
      this.pointViewMode = 'list';
      this.pointCurrentItem = null;
      this.pointAddMode = false;
      this.processViewMode = 'list';
      this.processCurrentItem = null;
      this.repairViewMode = 'list';
      this.repairCurrentItem = null;
      this.repairAddMode = false;
      this.showImagePreview = false;
      this.previewImageUrl = '';
      // 最后再切换tab
      this.activeTab = tab.label;
      
      // 使用nextTick确保DOM更新完成后再执行搜索
      this.$nextTick(() => {
        if (tab.label === '点位管理') {
          this.searchPoint();
        } else if (tab.label === '实时告警') {
          this.searchAlarm();
        } else if (tab.label === '历史查询') {
          this.searchHistory();
        } else if (tab.label === '处理流程') {
          this.searchProcess();
        } else if (tab.label === '设备维修') {
          this.searchRepair();
        }
      });
    },
    async searchHistory() {
      // 记录查询开始时间
      const startTime = new Date();
      console.log('=== 开始历史查询 ===');
      console.log('查询开始时间:', startTime.toISOString());
      console.log('查询参数:', this.historyQuery);
      
      try {
        // 构建查询参数，使用queryViolations接口
        const params = {
          plate_number: this.historyQuery.plateNumber || '',
          install_area: this.historyQuery.location || '',
          fac_id: this.historyQuery.deviceNumber || '',
          start_date: this.historyQuery.startDate ? this.formatDateForAPI(this.historyQuery.startDate) : '',
          end_date: this.historyQuery.endDate ? this.formatDateForAPI(this.historyQuery.endDate) : '',
          page: this.historyPage,
          per_page: this.historyPageSize
        };
        

        
        // 添加请求前的状态检查
        console.log('=== 请求前状态检查 ===');
        console.log('this.historyList 当前状态:', this.historyList);
        console.log('this.historyTotalPagesState 当前状态:', this.historyTotalPagesState);
        console.log('========================');
        
        const response = await queryViolations(params);
        
        console.log('=== 历史查询接口响应调试信息 ===');
        console.log('响应状态:', response.status);
        console.log('响应状态文本:', response.statusText);
        console.log('响应头:', response.headers);
        console.log('响应数据:', response.data);
        console.log('完整响应对象:', response);
        console.log('========================');
        
        // 检查响应数据结构
        if (response.data && Array.isArray(response.data.data)) {
          console.log('API返回数据:', response.data);
          console.log('数据数组长度:', response.data.data.length);
          
          // 转换API返回的数据格式为前端需要的格式
          this.historyList = response.data.data.map((item, index) => {
            console.log(`处理第${index + 1}条原始数据:`, item);
            
            // 解码Unicode编码的中文字符
            const decodeUnicode = (str) => {
              if (!str) return str;
              return str.replace(/\\u([0-9a-fA-F]{4})/g, (match, hex) => {
                return String.fromCharCode(parseInt(hex, 16));
              });
            };
            
            const processedItem = {
              id: item.violate_id || index + 1,
              deviceNumber: decodeUnicode(item.fac_id) || '未知设备',
              deviceName: decodeUnicode(item.fac_name) || '雷视一体机',
              location: decodeUnicode(item.install_area) || '未知位置',
              vehicleType: '货车', // 默认车辆类型
              plateNumber: decodeUnicode(item.plate_number) || '无车牌',
              violationTime: item.violate_date ? this.formatTime(item.violate_date) : '',
              originalCaptureTime: item.violate_date || '', // 保存原始时间用于图片获取
              speed: item.speed ? `${item.speed}km/h` : '',
              // 保存图片相关数据以备后用
              imageData: {
                violation_photo: this.convertImageUrl(item.violation_photo || ''),
                fac_id: item.fac_id || '',
                violate_date: item.violate_date || ''
              }
            };
            
            console.log(`处理后的历史记录第${index + 1}项:`, processedItem);
            return processedItem;
          });
          
          console.log('最终历史查询列表:', this.historyList);
          console.log('列表长度:', this.historyList.length);
          
          // 设置总页数
          if (response.data.total_pages) {
            this.historyTotalPagesState = response.data.total_pages;
            console.log('设置总页数:', this.historyTotalPagesState);
          }
          
          // 检查页码有效性，如果当前页超出总页数，重置为第一页
          if (this.historyTotalPagesState > 0 && this.historyPage > this.historyTotalPagesState) {
            console.log('当前页码超出总页数，重置为第1页');
              this.historyPage = 1;
            }
          
          // 强制触发Vue的响应式更新
          this.$forceUpdate();
          
          // 使用nextTick确保DOM更新完成
          this.$nextTick(() => {
            console.log('=== nextTick后的状态检查 ===');
            console.log('this.historyList:', this.historyList);
            console.log('this.pagedHistoryList:', this.pagedHistoryList);
            console.log('========================');
          });
        } else {
          console.error('查询历史记录失败: 响应数据格式不正确');
          console.error('response.data:', response.data);
          console.error('response.data.data:', response.data?.data);
          console.error('Array.isArray(response.data.data):', Array.isArray(response.data?.data));
          this.historyList = [];
          this.historyTotalPagesState = 1;
        }
        
        // 记录查询完成时间
        const endTime = new Date();
        const duration = endTime.getTime() - startTime.getTime();
        console.log('=== 历史查询完成 ===');
        console.log('查询完成时间:', endTime.toISOString());
        console.log('查询耗时:', duration + 'ms');
        console.log('查询结果数量:', this.historyList.length);
        console.log('历史查询成功', this.historyList);
        console.log('=== 查询后状态检查 ===');
        console.log('this.historyList 查询后状态:', this.historyList);
        console.log('this.historyTotalPagesState 查询后状态:', this.historyTotalPagesState);
        console.log('========================');
        
      } catch (error) {
        const endTime = new Date();
        const duration = endTime.getTime() - startTime.getTime();
        console.log('=== 历史查询失败 ===');
        console.log('查询失败时间:', endTime.toISOString());
        console.log('查询耗时:', duration + 'ms');
        console.error('历史查询失败:', error);
        console.error('错误详情:', {
          message: error.message,
          stack: error.stack,
          response: error.response,
          request: error.request
        });
        
        // 如果API调用失败，使用空列表
        this.historyList = [];
        this.historyTotalPagesState = 1;
      }
    },
    debugHistoryState() {
      console.log('=== 历史查询状态调试 ===');
      console.log('activeTab:', this.activeTab);
      console.log('historyViewMode:', this.historyViewMode);
      console.log('historyList:', this.historyList);
      console.log('historyList.length:', this.historyList ? this.historyList.length : 'undefined');
      console.log('historyPage:', this.historyPage);
      console.log('historyPageSize:', this.historyPageSize);
      console.log('historyTotalPagesState:', this.historyTotalPagesState);
      console.log('pagedHistoryList:', this.pagedHistoryList);
      console.log('pagedHistoryList.length:', this.pagedHistoryList ? this.pagedHistoryList.length : 'undefined');
      console.log('historyQuery:', this.historyQuery);
      console.log('=== 历史查询状态调试结束 ===');
      
      // 显示弹窗显示状态信息
      alert(`历史查询状态：
activeTab: ${this.activeTab}
historyViewMode: ${this.historyViewMode}
historyList长度: ${this.historyList ? this.historyList.length : 'undefined'}
当前页: ${this.historyPage}
每页数量: ${this.historyPageSize}
总页数状态: ${this.historyTotalPagesState}
分页后数据长度: ${this.pagedHistoryList ? this.pagedHistoryList.length : 'undefined'}
      `);
    },
    changeHistoryPage(page) {
      console.log('=== 历史查询分页切换 ===');
      console.log('当前页:', this.historyPage);
      console.log('目标页:', page);
      console.log('总页数:', this.historyTotalPages);
      console.log('总页数状态:', this.historyTotalPagesState);
      
      // 验证页码有效性 - 允许用户点击任何页码，让API来决定是否有效
      if (page < 1) {
        console.warn('页码不能小于1，忽略分页切换');
        return;
      }
      
      this.historyPage = page;
      console.log('设置新页码:', this.historyPage);
      
      // 重新查询数据
      this.searchHistory();
    },
    jumpHistoryPage() {
      let p = parseInt(this.historyPageInput);
      console.log('=== 历史查询页码跳转 ===');
      console.log('输入页码:', this.historyPageInput);
      console.log('解析后页码:', p);
      console.log('总页数:', this.historyTotalPages);
      console.log('总页数状态:', this.historyTotalPagesState);
      
      if (!isNaN(p) && p >= 1) {
        this.historyPage = p;
        console.log('设置新页码:', this.historyPage);
        this.searchHistory();
      } else {
        console.warn('页码无效，请输入大于等于1的数字');
        alert('请输入大于等于1的页码');
      }
    },
    async searchPoint() {
      this.pointPage = 1;
      try {
        const params = {
          fac_id: this.pointQuery.deviceNumber,
          factory_area: this.pointQuery.park,
          fac_point: this.pointQuery.location,
          start_date: this.pointQuery.startDate ? this.formatDateForAPI(this.pointQuery.startDate) : '',
          end_date: this.pointQuery.endDate ? this.formatDateForAPI(this.pointQuery.endDate) : '',
          page: this.pointPage,
          per_page: this.pointPageSize,
        };
        
        // 打印请求参数用于调试
        console.log('=== 点位管理搜索接口调用调试信息 ===');
        console.log('请求参数:', params);
        console.log('请求URL:', 'queryPointMessage API');
        console.log('请求方法:', 'POST/GET');
        console.log('========================');
        
        const response = await queryPointMessage(params);
        
        // 打印响应信息用于调试
        console.log('=== 点位管理搜索接口响应调试信息 ===');
        console.log('响应状态:', response.status);
        console.log('响应数据:', response.data);
        console.log('========================');
        
        this.pointList = response.data.data.map(item => ({
          id: item.fac_id,
          // 保持原始字段名，确保编辑时能正确显示
          fac_id: item.fac_id,
          fac_name: item.fac_name,
          fac_model: item.fac_model,
          fac_state: item.fac_state,
          fac_point: item.fac_point,
          detail_location: item.detail_location,
          factory_area: item.factory_area,
          manufacturer: item.manufacturer,
          install_instruction: item.install_instruction,
          install_date: item.install_date ? this.formatTime(item.install_date) : '',
          install_photo_url: this.processImageUrl(item.install_photo_url),
          applicant: item.applicant,
          // 同时保留兼容字段
          deviceNumber: item.fac_id,
          deviceName: item.fac_name,
          deviceType: item.fac_model,
          status: item.fac_state,
          location: this.deviceLocationMap[item.fac_id] || item.fac_point,
        }));
        this.pointTotalPagesState = response.data.total_pages;
      } catch (error) {
        console.error("获取点位列表失败", error);
      }
    },

    addPoint() {
      this.pointAddMode = true;
      this.pointAddItem = {
        fac_id: '',
        fac_name: '',
        fac_model: '摄像头',
        fac_state: '在线',
        fac_point: '',
        detail_location: '',
        factory_area: '',
        manufacturer: '',
        install_instruction: '',
        install_date: '',
        install_seconds: 0,
        install_photo: '',
        applicant: ''
      };
    },
    changePointPage(page) {
      this.pointPage = page;
      this.queryPointMessage();
    },
    jumpPointPage() {
      let p = parseInt(this.pointPageInput);
      if (!isNaN(p) && p >= 1 && p <= this.pointTotalPages) {
        this.pointPage = p;
        this.queryPointMessage();
      }
    },
    async searchProcess() {
      try {
        // 构建查询参数，根据表单输入构建
        const params = {
          plate_number: this.processQuery.plateNumber || '',
          install_area: this.processQuery.location || '',
          fac_id: this.processQuery.deviceNumber || '',
          vehicle_type: this.processQuery.vehicleType || '',
          start_date: this.processQuery.startDate ? this.formatDateForAPI(this.processQuery.startDate) : '',
          end_date: this.processQuery.endDate ? this.formatDateForAPI(this.processQuery.endDate) : '',
          page: this.processPage,
          per_page: this.processPageSize
        };
        
        console.log('=== 开始查询处理流程 ===');
        console.log('查询参数:', params);
        
        const response = await queryViolations(params);
        console.log('API响应:', response);
        
        // 检查响应数据结构
        if (response.data && Array.isArray(response.data.data)) {
          console.log('API返回数据:', response.data);
          
          // 转换API返回的数据格式为前端需要的格式
          this.processList = response.data.data.map(item => {
            // 解码Unicode编码的中文字符
            const decodeUnicode = (str) => {
              if (!str) return str;
              return str.replace(/\\u([0-9a-fA-F]{4})/g, (match, hex) => {
                return String.fromCharCode(parseInt(hex, 16));
              });
            };
            
            const processedItem = {
              id: item.id || item.violate_id,
              violationNumber: item.violate_id || item.violationNumber,
              deviceNumber: decodeUnicode(item.fac_id) || item.deviceNumber || item.deviceName,
              deviceType: decodeUnicode(item.fac_type) || item.deviceType || '摄像头',
              location: decodeUnicode(item.install_area) || item.location,
              vehicleType: decodeUnicode(item.vehicle_type) || item.vehicleType || '货车',
              violationPerson: item.violator || item.violationPerson || '未知',
              plateNumber: decodeUnicode(item.plate_number) || item.plateNumber,
              violationTime: item.violate_date ? this.formatTime(item.violate_date) : (item.violationTime ? this.formatTime(item.violationTime) : ''),
              status: item.process_instruction && item.process_instruction !== 'null' ? '已解决' : '未解决',
              process_instruction: item.process_instruction,
              speed: item.speed.toString() + "km/h",
            };
            
            console.log('处理后的数据项:', processedItem);
            return processedItem;
          });
          
          console.log('最终处理流程列表:', this.processList);
          
          // 设置总页数状态（如果有API分页信息）
          if (response.data.total_pages) {
            this.processTotalPagesState = response.data.total_pages;
            console.log('设置处理流程总页数:', this.processTotalPagesState);
          }
          
          // 检查页码有效性，如果当前页超出总页数，重置为第一页
          if (this.processTotalPagesState > 0 && this.processPage > this.processTotalPagesState) {
            console.log('当前页码超出总页数，重置为第1页');
          this.processPage = 1;
          }
        } else {
          console.error('查询处理流程失败:', response.data.message);
        }
      } catch (error) {
        console.error('查询处理流程失败:', error);
        // 如果API调用失败，使用模拟数据
        this.processList = [

        ];
      }
    },

    changeProcessPage(page) {
      console.log('=== 处理流程分页切换 ===');
      console.log('当前页:', this.processPage);
      console.log('目标页:', page);
      console.log('总页数:', this.processTotalPages);
      
      // 验证页码有效性
      if (page < 1) {
        console.warn('页码不能小于1，忽略分页切换');
        return;
      }
      
      this.processPage = page;
      console.log('设置新页码:', this.processPage);
      
      // 重新查询数据
      this.searchProcess();
    },
    jumpProcessPage() {
      let p = parseInt(this.processPageInput);
      if (!isNaN(p) && p >= 1) {
        this.processPage = p;
        // 重新查询数据
        this.searchProcess();
      } else {
        console.warn('页码无效，请输入大于等于1的数字');
        alert('请输入大于等于1的页码');
      }
    },
    async searchRepair() {
      try {
        const params = {
          fac_message: this.repairQuery.deviceNumber,
          resolution_state: this.repairQuery.resolutionState,
          start_date: this.repairQuery.startDate ? this.formatDateForAPI(this.repairQuery.startDate) : '',
          end_date: this.repairQuery.endDate ? this.formatDateForAPI(this.repairQuery.endDate) : '',
          page: this.repairPage,
          per_page: this.repairPageSize,
        };
        
        console.log('=== 设备维修查询参数 ===');
        console.log('查询参数:', params);
        
        const response = await queryMaintenance(params);
        console.log('=== 设备维修API响应 ===');
        console.log('完整响应:', response);
        console.log('响应数据:', response.data);
        
        // 检查响应数据结构
        if (response.data && Array.isArray(response.data.data)) {
          // 转换API返回的数据格式为前端需要的格式
          this.repairList = response.data.data.map(item => {
            

            
            // 处理null值，提供默认值
            const processedItem = {
              id: item.maintenance_id || item.id || '未知ID',
              maintenance_id: item.maintenance_id || item.id || '未知ID',
              deviceNumber: item.fac_id || '未知设备',
              deviceName: item.fac_name || '未知设备名称',
              installType: item.fac_point ? '摄像头' : '摄像头', // 默认摄像头
              installLocation: item.fac_point || '未知位置',
              reporter: item.applicant || '未知申报人',
              reportTime: item.applicant_date ? this.formatTime(item.applicant_date) : (item.resolution_date ? this.formatTime(item.resolution_date) : ''),
              faultImage: this.processImageUrl(item.fault_photo_url) || null,
              faultDesc: item.fault_description || '无故障描述',
              solveStatus: item.resolution_state || '未解决',
              solveDesc: item.resolution_description || '无解决说明',
              solveImage: this.processImageUrl(item.resolution_photo_url) || null,
              solver: item.resolution_people || '未知解决人',
              solveTime: item.resolution_date ? this.formatTime(item.resolution_date) : ''
            };
            
            console.log('处理后的维修数据项:', processedItem);
            return processedItem;
          });
          
          // 更新分页信息
          this.repairTotalPagesState = response.data.total_pages || 1;
          
          // 检查页码有效性，如果当前页超出总页数，重置为第一页
          if (this.repairTotalPagesState > 0 && this.repairPage > this.repairTotalPagesState) {
            console.log('当前页码超出总页数，重置为第1页');
            this.repairPage = 1;
          }
          
          console.log('=== 设备维修查询成功 ===');
          console.log('维修列表:', this.repairList);
          console.log('总页数:', this.repairTotalPagesState);
          console.log('当前页:', this.repairPage);
        } else {
          console.error('查询设备维修失败: 响应数据格式不正确');
          console.log('响应数据结构:', response.data);
          this.repairList = [];
        }
      } catch (error) {
        console.error('查询设备维修失败:', error);
        this.repairList = [];
      }
    },
    addRepair() {
      console.log('=== 开始新增设备维修 ===');
      this.repairAddMode = true;
      this.repairAddItem = {
        maintenance_id: this.generateMaintenanceId(),
        deviceNumber: '',
        deviceName: '',
        installType: '摄像头',
        installLocation: '',
        reporter: '',
        reportTime: this.formatDateForAPI(new Date().toISOString()),
        faultImage: null,
        faultDesc: '',
        solveStatus: '未解决',
        solveDesc: '',
        solveImage: null,
        solver: '',
        solveTime: ''
      };
      console.log('新增维修项初始化完成:', this.repairAddItem);
      console.log('=== 新增设备维修初始化完成 ===');
    },
    changeRepairPage(page) {
      this.repairPage = page;
      this.searchRepair();
    },
    
    jumpRepairPage() {
      let p = parseInt(this.repairPageInput);
      if (!isNaN(p) && p >= 1 && p <= this.repairTotalPages) {
        this.repairPage = p;
        this.searchRepair();
      }
    },
    async searchAlarm() {
      // 记录查询开始时间
      const startTime = new Date();
      console.log('=== 开始实时告警查询 ===');
      console.log('查询开始时间:', startTime.toISOString());
      console.log('查询参数:', this.alarmQuery);
      
      try {
        // 构建查询参数，使用queryViolations接口，与历史查询保持一致
        const params = {
          plate_number: '', // 实时告警不限制车牌号
          install_area: this.alarmQuery.location || '',
          fac_id: this.alarmQuery.deviceNumber || '',
          start_date: this.formatDateForAPI(new Date().toISOString()), // 今天
          end_date: this.formatDateForAPI(new Date().toISOString()), // 今天
          page: this.alarmPage,
          per_page: this.alarmPageSize
        };
        


        const response = await queryViolations(params);


        // 检查响应数据结构
        if (response.data && Array.isArray(response.data.data)) {
          console.log('API返回数据:', response.data);
          console.log('数据数组长度:', response.data.data.length);
          
          // 转换API返回的数据格式为前端需要的格式
          this.alarmList = response.data.data.map((item, index) => {
            console.log(`处理第${index + 1}条实时告警数据:`, item);
            
            // 解码Unicode编码的中文字符
            const decodeUnicode = (str) => {
              if (!str) return str;
              return str.replace(/\\u([0-9a-fA-F]{4})/g, (match, hex) => {
                return String.fromCharCode(parseInt(hex, 16));
              });
            };
            
            const processedItem = {
              id: item.violate_id || index + 1,
              plateNumber: decodeUnicode(item.plate_number) || '无车牌',
              violation: '超速',
              speed: item.speed ? `${item.speed}km/h` : '',
              updateTime: item.violate_date ? this.formatTime(item.violate_date) : '',
              originalCaptureTime: item.violate_date || '', // 保存原始时间用于图片获取
              location: decodeUnicode(item.install_area) || '未知位置',
              deviceNumber: decodeUnicode(item.fac_id) || '未知设备',
              // 保存图片相关数据以备后用
              imageData: {
                violation_photo: this.convertImageUrl(item.violation_photo || ''),
                fac_id: item.fac_id || '',
                violate_date: item.violate_date || ''
              }
            };
            
            console.log(`处理后的实时告警第${index + 1}项:`, processedItem);
            return processedItem;
          });
          
          console.log('最终实时告警列表:', this.alarmList);
          console.log('列表长度:', this.alarmList.length);
          
          // 设置总页数状态（如果有API分页信息）
          if (response.data.total_pages) {
            this.alarmTotalPagesState = response.data.total_pages;
            console.log('设置实时告警总页数:', this.alarmTotalPagesState);
        }

          // 检查页码有效性，如果当前页超出总页数，重置为第一页
          if (this.alarmTotalPagesState > 0 && this.alarmPage > this.alarmTotalPagesState) {
            console.log('当前页码超出总页数，重置为第1页');
        this.alarmPage = 1;
          }
        
        // 记录查询完成时间
        const endTime = new Date();
        const duration = endTime.getTime() - startTime.getTime();
        console.log('=== 实时告警查询完成 ===');
        console.log('查询完成时间:', endTime.toISOString());
        console.log('查询耗时:', duration + 'ms');
        console.log('查询结果数量:', this.alarmList.length);
        console.log('实时告警查询成功', this.alarmList);
        
        // 只自动加载第一个告警的图片
        if (this.alarmList.length > 0) {
          this.loadFirstAlarmImage();
          }
          
        } else {
          console.error('查询实时告警失败: 响应数据格式不正确');
          console.error('response.data:', response.data);
          console.error('response.data.data:', response.data?.data);
          console.error('Array.isArray(response.data.data):', Array.isArray(response.data?.data));
          this.alarmList = [];
        }
        
      } catch (error) {
        const endTime = new Date();
        const duration = endTime.getTime() - startTime.getTime();
        console.log('=== 实时告警查询失败 ===');
        console.log('查询失败时间:', endTime.toISOString());
        console.log('查询耗时:', duration + 'ms');
        console.error('实时告警查询失败:', error);
        console.error('错误详情:', {
          message: error.message,
          stack: error.stack,
          response: error.response,
          request: error.request
        });
        
        // 如果API调用失败，使用空列表
        this.alarmList = [];
      }
    },
    async printAlarm() {
  try {
    console.log('=== 开始打印实时告警数据 ===');
    
    // 构建查询参数，设置perpage为500获取所有数据
    const params = {
      plate_number: '', // 实时告警不限制车牌号
      install_area: this.alarmQuery.location || '',
      fac_id: this.alarmQuery.deviceNumber || '',
      start_date: this.formatDateForAPI(new Date().toISOString()), // 今天
      end_date: this.formatDateForAPI(new Date().toISOString()), // 今天
      page: 1, // 从第一页开始
      per_page: 500 // 设置每页500条数据
    };
    
    console.log('打印查询参数:', params);
    
    // 调用API获取所有数据
    const response = await queryViolations(params);
    
    console.log('打印API响应:', response);
    
    let allAlarmData = [];
    
    // 检查响应数据结构
    if (response.data && Array.isArray(response.data.data)) {
      console.log('API返回数据:', response.data);
      console.log('数据数组长度:', response.data.data.length);
      
      // 转换API返回的数据格式为前端需要的格式
      allAlarmData = response.data.data.map((item, index) => {
        console.log(`处理第${index + 1}条打印数据:`, item);
        
        // 解码Unicode编码的中文字符
        const decodeUnicode = (str) => {
          if (!str) return str;
          return str.replace(/\\u([0-9a-fA-F]{4})/g, (match, hex) => {
            return String.fromCharCode(parseInt(hex, 16));
          });
        };
        
        const processedItem = {
          id: item.violate_id || index + 1,
          plateNumber: decodeUnicode(item.plate_number) || '无车牌',
          violation: '超速',
          speed: item.speed ? `${item.speed}km/h` : '',
          updateTime: item.violate_date ? this.formatTime(item.violate_date) : ''
        };
        
        console.log(`处理后的打印数据第${index + 1}项:`, processedItem);
        return processedItem;
      });
      
      console.log('最终打印数据列表:', allAlarmData);
      console.log('打印数据列表长度:', allAlarmData.length);
    } else {
      console.error('打印数据获取失败: 响应数据格式不正确');
      console.error('response.data:', response.data);
      allAlarmData = [];
    }
    
    // 生成打印内容
    const printContent = `
      <div style="padding: 20px;">
        <h2 style="text-align: center; margin-bottom: 20px;">实时告警列表</h2>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          打印时间: ${new Date().toLocaleString('zh-CN')}
        </div>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          总记录数: ${allAlarmData.length} 条
        </div>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
          <thead>
            <tr style="background: #f5f5f5;">
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">车牌</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">车道违规</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">车速</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">更新时间</th>
            </tr>
          </thead>
          <tbody>
            ${allAlarmData.map((item) => `
              <tr>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.plateNumber}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.violation}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.speed}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.updateTime}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `;
    
    // 打开打印窗口
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
    
    console.log('=== 实时告警打印完成 ===');
    
  } catch (error) {
    console.error('打印实时告警数据失败:', error);
    alert('打印失败，请查看控制台');
  }
},

// 修改点位管理的打印功能
async printPoint() {
  try {
    console.log('=== 开始打印点位管理数据 ===');
    
    // 构建查询参数，设置perpage为500获取所有数据
    const params = {
      fac_id: this.pointQuery.deviceNumber,
      factory_area: this.pointQuery.park,
      fac_point: this.pointQuery.location,
      start_date: this.pointQuery.startDate ? this.formatDateForAPI(this.pointQuery.startDate) : '',
      end_date: this.pointQuery.endDate ? this.formatDateForAPI(this.pointQuery.endDate) : '',
      page: 1, // 从第一页开始
      per_page: 500 // 设置每页500条数据
    };
    
    console.log('打印查询参数:', params);
    
    // 调用API获取所有数据
    const response = await queryPointMessage(params);
    
    console.log('打印API响应:', response);
    
    let allPointData = [];
    
    // 检查响应数据结构
    if (response.data && Array.isArray(response.data.data)) {
      console.log('API返回数据:', response.data);
      console.log('数据数组长度:', response.data.data.length);
      
      // 转换API返回的数据格式为前端需要的格式
      allPointData = response.data.data.map((item, index) => {
        console.log(`处理第${index + 1}条打印数据:`, item);
        
        const processedItem = {
          id: item.fac_id,
          deviceNumber: item.fac_id,
          deviceName: item.fac_name,
          status: item.fac_state,
          location: this.deviceLocationMap[item.fac_id] || item.fac_point,
          manufacturer: item.manufacturer,
          factory_area: item.factory_area
        };
        
        console.log(`处理后的打印数据第${index + 1}项:`, processedItem);
        return processedItem;
      });
      
      console.log('最终打印数据列表:', allPointData);
      console.log('打印数据列表长度:', allPointData.length);
    } else {
      console.error('打印数据获取失败: 响应数据格式不正确');
      console.error('response.data:', response.data);
      allPointData = [];
    }
    
    // 生成打印内容
    const printContent = `
      <div style="padding: 20px;">
        <h2 style="text-align: center; margin-bottom: 20px;">点位管理列表</h2>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          打印时间: ${new Date().toLocaleString('zh-CN')}
        </div>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          总记录数: ${allPointData.length} 条
        </div>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
          <thead>
            <tr style="background: #f5f5f5;">
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">序号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备编号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备名称</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">状态</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">点位</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">生产厂家</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">所属厂区</th>
            </tr>
          </thead>
          <tbody>
            ${allPointData.map((item, idx) => `
              <tr>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${idx + 1}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.deviceNumber}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.deviceName}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.status}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.location}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.manufacturer}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.factory_area}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `;
    
    // 打开打印窗口
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
    
    console.log('=== 点位管理打印完成 ===');
    
  } catch (error) {
    console.error('打印点位管理数据失败:', error);
    alert('打印失败，请查看控制台');
  }
},

// 修改处理流程的打印功能
async printProcess() {
  try {
    console.log('=== 开始打印处理流程数据 ===');
    
    // 构建查询参数，设置perpage为500获取所有数据
    const params = {
      plate_number: this.processQuery.plateNumber || '',
      install_area: this.processQuery.location || '',
      fac_id: this.processQuery.deviceNumber || '',
      vehicle_type: this.processQuery.vehicleType || '',
      start_date: this.processQuery.startDate ? this.formatDateForAPI(this.processQuery.startDate) : '',
      end_date: this.processQuery.endDate ? this.formatDateForAPI(this.processQuery.endDate) : '',
      page: 1, // 从第一页开始
      per_page: 500 // 设置每页500条数据
    };
    
    console.log('打印查询参数:', params);
    
    // 调用API获取所有数据
    const response = await queryViolations(params);
    
    console.log('打印API响应:', response);
    
    let allProcessData = [];
    
    // 检查响应数据结构
    if (response.data && Array.isArray(response.data.data)) {
      console.log('API返回数据:', response.data);
      console.log('数据数组长度:', response.data.data.length);
      
      // 转换API返回的数据格式为前端需要的格式
      allProcessData = response.data.data.map((item, index) => {
        console.log(`处理第${index + 1}条打印数据:`, item);
        
        // 解码Unicode编码的中文字符
        const decodeUnicode = (str) => {
          if (!str) return str;
          return str.replace(/\\u([0-9a-fA-F]{4})/g, (match, hex) => {
            return String.fromCharCode(parseInt(hex, 16));
          });
        };
        
        const processedItem = {
          id: item.id || item.violate_id,
          violationNumber: item.violate_id || item.violationNumber,
          deviceNumber: decodeUnicode(item.fac_id) || item.deviceNumber || item.deviceName,
          deviceType: decodeUnicode(item.fac_type) || item.deviceType || '摄像头',
          location: decodeUnicode(item.install_area) || item.location,
          vehicleType: decodeUnicode(item.vehicle_type) || item.vehicleType || '货车',
          violationPerson: item.violator || item.violationPerson || '未知',
          plateNumber: decodeUnicode(item.plate_number) || item.plateNumber,
          violationTime: item.violate_date ? this.formatTime(item.violate_date) : (item.violationTime ? this.formatTime(item.violationTime) : ''),
          status: item.process_instruction && item.process_instruction !== 'null' ? '已解决' : '未解决'
        };
        
        console.log(`处理后的打印数据第${index + 1}项:`, processedItem);
        return processedItem;
      });
      
      console.log('最终打印数据列表:', allProcessData);
      console.log('打印数据列表长度:', allProcessData.length);
    } else {
      console.error('打印数据获取失败: 响应数据格式不正确');
      console.error('response.data:', response.data);
      allProcessData = [];
    }
    
    // 生成打印内容
    const printContent = `
      <div style="padding: 20px;">
        <h2 style="text-align: center; margin-bottom: 20px;">处理流程列表</h2>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          打印时间: ${new Date().toLocaleString('zh-CN')}
        </div>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          总记录数: ${allProcessData.length} 条
        </div>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
          <thead>
            <tr style="background: #f5f5f5;">
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">序号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">违规编号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备编号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备类型</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">安装位置</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">车辆类型</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">违规人</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">车牌号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">违规时间</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">处理状态</th>
            </tr>
          </thead>
          <tbody>
            ${allProcessData.map((item, idx) => `
              <tr>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${idx + 1}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.violationNumber}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.deviceNumber}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.deviceType}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.location}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.vehicleType}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.violationPerson}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.plateNumber}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.violationTime}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.status}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `;
    
    // 打开打印窗口
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
    
    console.log('=== 处理流程打印完成 ===');
    
  } catch (error) {
    console.error('打印处理流程数据失败:', error);
    alert('打印失败，请查看控制台');
  }
},

// 修改设备维修的打印功能
async printRepair() {
  try {
    console.log('=== 开始打印设备维修数据 ===');
    
    // 构建查询参数，设置perpage为500获取所有数据
    const params = {
      fac_message: this.repairQuery.deviceNumber,
      resolution_state: this.repairQuery.resolutionState,
      start_date: this.repairQuery.startDate ? this.formatDateForAPI(this.repairQuery.startDate) : '',
      end_date: this.repairQuery.endDate ? this.formatDateForAPI(this.repairQuery.endDate) : '',
      page: 1, // 从第一页开始
      per_page: 500 // 设置每页500条数据
    };
    
    console.log('打印查询参数:', params);
    
    // 调用API获取所有数据
    const response = await queryMaintenance(params);
    
    console.log('打印API响应:', response);
    
    let allRepairData = [];
    
    // 检查响应数据结构
    if (response.data && Array.isArray(response.data.data)) {
      console.log('API返回数据:', response.data);
      console.log('数据数组长度:', response.data.data.length);
      
      // 转换API返回的数据格式为前端需要的格式
      allRepairData = response.data.data.map((item, index) => {
        console.log(`处理第${index + 1}条打印数据:`, item);
        
        const processedItem = {
          id: item.maintenance_id || item.id || '未知ID',
          maintenance_id: item.maintenance_id || item.id || '未知ID',
          deviceNumber: item.fac_id || '未知设备',
          deviceName: item.fac_name || '未知设备名称',
          installType: item.fac_point ? '摄像头' : '摄像头', // 默认摄像头
          installLocation: item.fac_point || '未知位置',
          reporter: item.applicant || '未知申报人',
          reportTime: item.applicant_date ? this.formatTime(item.applicant_date) : (item.resolution_date ? this.formatTime(item.resolution_date) : ''),
          faultImage: this.processImageUrl(item.fault_photo_url) || null,
          faultDesc: item.fault_description || '无故障描述',
          solveStatus: item.resolution_state || '未解决',
          solveDesc: item.resolution_description || '无解决说明',
          solveImage: this.processImageUrl(item.resolution_photo_url) || null,
          solver: item.resolution_people || '未知解决人',
          solveTime: item.resolution_date ? this.formatTime(item.resolution_date) : ''
        };
        
        console.log(`处理后的打印数据第${index + 1}项:`, processedItem);
        return processedItem;
      });
      
      console.log('最终打印数据列表:', allRepairData);
      console.log('打印数据列表长度:', allRepairData.length);
    } else {
      console.error('打印数据获取失败: 响应数据格式不正确');
      console.error('response.data:', response.data);
      allRepairData = [];
    }
    
    // 生成打印内容
    const printContent = `
      <div style="padding: 20px;">
        <h2 style="text-align: center; margin-bottom: 20px;">设备维修列表</h2>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          打印时间: ${new Date().toLocaleString('zh-CN')}
        </div>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          总记录数: ${allRepairData.length} 条
        </div>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
          <thead>
            <tr style="background: #f5f5f5;">
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">序号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">维修ID</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备编号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备名称</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">安装类型</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">安装位置</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">申报人</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">申报时间</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">故障说明</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">故障图片</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">解决状态</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">解决说明</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">解决图片</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">解决人</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">解决时间</th>
            </tr>
          </thead>
          <tbody>
            ${allRepairData.map((item, idx) => `
              <tr>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${idx + 1}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.maintenance_id}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.deviceNumber}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.deviceName}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.installType}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.installLocation}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.reporter}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.reportTime}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.faultDesc}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.faultImage ? '有' : '无'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.solveStatus}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.solveDesc}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.solveImage ? '有' : '无'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.solver || ''}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.solveTime || ''}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `;
    
    // 打开打印窗口
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
    
    console.log('=== 设备维修打印完成 ===');
    
  } catch (error) {
    console.error('打印设备维修数据失败:', error);
    alert('打印失败，请查看控制台');
  }
},
    changeAlarmPage(page) {
      console.log('=== 实时告警分页切换 ===');
      console.log('当前页:', this.alarmPage);
      console.log('目标页:', page);
      console.log('总页数:', this.alarmTotalPages);
      
      // 验证页码有效性
      if (page < 1) {
        console.warn('页码不能小于1，忽略分页切换');
        return;
      }
      
      this.alarmPage = page;
      console.log('设置新页码:', this.alarmPage);
      
      // 重新查询数据
      this.searchAlarm();
    },
    jumpAlarmPage() {
      let p = parseInt(this.alarmPageInput);
      if (!isNaN(p) && p >= 1) {
        this.alarmPage = p;
        // 重新查询数据
        this.searchAlarm();
      } else {
        console.warn('页码无效，请输入大于等于1的数字');
        alert('请输入大于等于1的页码');
      }
    },
    async showHistoryView(item) {
      this.historyCurrentItem = item;
      this.historyViewMode = 'view';
      
      // 如果还没有图片，则加载图片
      if (item.imageData && !item.imageUrl) {
        try {
          console.log('开始加载历史记录图片:', item);
          
          // 新的数据格式中，图片URL直接存储在violation_photo字段中
          if (item.imageData.violation_photo) {
            // 转换图片URL格式并直接使用violation_photo作为图片URL
            item.imageUrl = this.convertImageUrl(item.imageData.violation_photo);
            console.log('历史记录图片加载成功，使用violation_photo:', item.imageUrl);
          } else {
            // 如果没有violation_photo，尝试使用旧的getCaptureImage方法
            const imageUrl = await this.getCaptureImage(
              item.imageData,
              item.originalCaptureTime || item.violationTime
            );
            
            if (imageUrl) {
              item.imageUrl = imageUrl;
              console.log('历史记录图片加载成功');
            } else {
              console.warn('历史记录图片加载失败');
            }
          }
        } catch (error) {
          console.error('加载历史记录图片失败:', error);
        }
      }
    },
    showHistoryEdit(item) {
      this.historyCurrentItem = item;
      this.historyViewMode = 'edit';
    },
    closeHistoryDetail() {
      this.historyViewMode = 'list';
      this.historyCurrentItem = null;
    },
    // 添加点位管理相关方法
    showPointView(item) {
      // 详情模式，深拷贝防止误改
      this.pointDetailItem = { ...item };
      this.pointDetailMode = 'view';
    },
    showPointEdit(item) {
      // 编辑模式，深拷贝
      this.pointDetailItem = { ...item };
      let dateTime = this.pointDetailItem.install_date;
      dateTime = dateTime.replace(/\//g, '-');
      dateTime = dateTime.replace(' ', 'T');
      this.pointDetailItem.install_date = dateTime;
      this.pointDetailMode = 'edit';
    },
    closePointDetailModal() {
      this.pointDetailMode = '';
      this.pointDetailItem = null;
    },
    onPointDetailImageChange(e) {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (ev) => {
        this.pointDetailItem.installPhotoUrl = ev.target.result;
      };
      reader.readAsDataURL(file);
    }
    },
    // 新增：图片点击预览大图
    previewImage(url) {
      this.previewImageUrl = url;
      this.showImagePreview = true;
    },
    closeImagePreview() {
      this.showImagePreview = false;
      this.previewImageUrl = '';
    },

    async savePointEdit() {
      try {
        // 创建FormData对象，用于上传文件
        const formData = new FormData();
        formData.append('fac_id', this.pointDetailItem.deviceNumber);
        formData.append('fac_name', this.pointDetailItem.deviceName);
        formData.append('fac_model', this.pointDetailItem.deviceType);
        formData.append('fac_state', this.pointDetailItem.status);
        formData.append('fac_point', this.pointDetailItem.fac_point);
        formData.append('detail_location', this.pointDetailItem.detail_location);
        formData.append('factory_area', this.pointDetailItem.factory_area);
        formData.append('manufacturer', this.pointDetailItem.manufacturer);
        formData.append('install_instruction', this.pointDetailItem.install_instruction);
        let dateTime = this.pointDetailItem.install_date;
        dateTime = dateTime.replace('T', ' ')
        formData.append('install_date', dateTime);
        formData.append('applicant', this.pointDetailItem.applicant);
        
        // 处理安装图片字段
        if (this.pointDetailItem.installPhotoUrl) {
          // 如果图片是base64格式，转换为Blob
          if (this.pointDetailItem.installPhotoUrl.startsWith('data:')) {
            const arr = this.pointDetailItem.installPhotoUrl.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            const blob = new Blob([u8arr], { type: mime });
            formData.append('install_photo', blob, 'install_photo.jpg');
          } else {
            // 如果已经是URL，直接添加
            formData.append('install_photo_url', this.pointDetailItem.installPhotoUrl);
          }
        }

        // 调用同一个接口保存编辑
        const response = await createPointMessage(formData);
        const result = response.data;
        
        if (result.status === 'success') {
          // 编辑成功，关闭弹窗并刷新数据
          this.pointDetailMode = '';
          this.pointDetailItem = null;
          this.searchPoint();
        } else {
          throw new Error(result.message || '编辑失败');
        }
      } catch (error) {
        console.error('编辑点位信息失败:', error);
      }
    },

    // 添加处理流程相关方法
    showProcessView(item) {
      console.log('=== 显示处理流程详情 ===');
      console.log('传入的item:', item);
      
      // 确保数据完整性，提供默认值
      this.processCurrentItem = {
        ...item,
        deviceType: item.deviceType || '摄像头',
        vehicleType: item.vehicleType || '货车',
        status: item.status || '未解决'
      };
      
      console.log('设置后的processCurrentItem:', this.processCurrentItem);
      this.processViewMode = 'view';
    },
    showProcessEdit(item) {
      console.log('=== 显示处理流程编辑 ===');
      console.log('传入的item:', item);
      
      // 确保数据完整性，提供默认值
      this.processCurrentItem = {
        ...item,
        processPerson: item.processPerson || '系统管理员',
        processTime: item.processTime || this.formatDateForAPI(new Date().toISOString()),
        processInstruction: item.process_instruction || (item.status === '已解决' ? '违规已处理' : '违规待处理'),
        status: item.status || '未解决'
      };
      
      console.log('设置后的processCurrentItem:', this.processCurrentItem);
      this.processViewMode = 'edit';
    },
    closeProcessDetail() {
      this.processViewMode = 'list';
      this.processCurrentItem = null;
    },
    
    async saveProcessEdit() {
      try {
        // 验证必填字段
        if (!this.processCurrentItem.processPerson || !this.processCurrentItem.processTime) {
          alert('请填写处理人和处理时间信息');
          return;
        }
        
        // 使用URLSearchParams替代对象
        const params = new URLSearchParams();
        
        // 发送违规人字段和其他处理信息
        params.append('violate_id', this.processCurrentItem.violationNumber || '');
        params.append('violator', this.processCurrentItem.violationPerson || '');
        params.append('process_person', this.processCurrentItem.processPerson);
        params.append('process_date', this.formatTimeForBackend(this.processCurrentItem.processTime));
        params.append('process_state', this.processCurrentItem.status === '已解决' ? '已处理' : '未处理');
        params.append('process_instruction', this.processCurrentItem.processInstruction);
        
        // 详细打印请求信息
        console.log('=== 处理流程编辑接口调用调试信息 ===');
        console.log('当前编辑项:', this.processCurrentItem);
        console.log('URLSearchParams内容:');
        for (let pair of params.entries()) {
          console.log(pair[0], pair[1]);
        }
        console.log('请求URL:', 'createViolation API');
        console.log('请求方法:', 'POST');
        console.log('========================');
        
        const response = await createViolation(params);
        
        // 详细打印响应信息
        console.log('=== 处理流程编辑接口响应调试信息 ===');
        console.log('响应状态:', response.status);
        console.log('响应状态文本:', response.statusText);
        console.log('响应头:', response.headers);
        console.log('响应数据:', response.data);
        console.log('完整响应对象:', response);
        console.log('========================');
        
        if (response.data.status === 'success') {
          alert('保存成功');
          this.closeProcessDetail();
          this.searchProcess(); // 重新加载列表
        } else {
          alert('保存失败: ' + (response.data.message || '未知错误'));
        }
      } catch (error) {
        console.error('=== 处理流程编辑接口调用失败 ===');
        console.error('错误详情:', error);
        console.error('错误消息:', error.message);
        console.error('错误堆栈:', error.stack);
        console.error('========================');
        alert('保存失败，请查看控制台');
      }
    },
    
    addProcess() {
              // 创建新的违规记录
        this.processCurrentItem = {
          id: Date.now(),
          violationNumber: 'VIOL' + Date.now(),
          deviceNumber: '',
          deviceType: '摄像头',
          location: '',
          vehicleType: '货车',
          violationPerson: '',
          plateNumber: '',
          violationTime: this.formatDateForAPI(new Date().toISOString()),
          status: '未解决'
        };
      this.processViewMode = 'add';
    },
    
    async saveProcessAdd() {
      try {
        // 验证必填字段
        if (!this.processCurrentItem.deviceNumber || !this.processCurrentItem.plateNumber || !this.processCurrentItem.violationPerson) {
          alert('请填写设备编号、车牌号和违规人信息');
          return;
        }
        
        // 根据安装位置判断所属厂区
        let factoryArea = '泰山路厂区';
        if (this.processCurrentItem.location.includes('北门') || 
            this.processCurrentItem.location.includes('B门') || 
            this.processCurrentItem.location.includes('C门') || 
            this.processCurrentItem.location.includes('D门')) {
          factoryArea = '泰山路厂区';
        }
        
        // 构建FormData对象，匹配后端期望的POST表单格式
        const formData = new FormData();
        formData.append('violate_id', this.processCurrentItem.violationNumber);
        formData.append('fac_id', this.processCurrentItem.deviceNumber);
        formData.append('fac_name', this.processCurrentItem.deviceNumber);
        formData.append('install_area', this.processCurrentItem.location);
        formData.append('fac_type', this.processCurrentItem.deviceType);
        formData.append('identify_type', '车牌识别');
        formData.append('factory_area', factoryArea);
        formData.append('violator', this.processCurrentItem.violationPerson);
        formData.append('violate_date', this.processCurrentItem.violationTime);
        formData.append('violate_instruction', '超速违规');
        formData.append('process_person', '系统管理员');
        formData.append('process_date', this.formatDateForAPI(new Date().toISOString()));
        formData.append('process_state', this.processCurrentItem.status === '已解决' ? '已处理' : '未处理');
        formData.append('process_instruction', this.processCurrentItem.status === '已解决' ? '违规已处理' : '违规待处理');
        
        // 详细打印请求信息用于调试
        console.log('=== 处理流程新增接口调用调试信息 ===');
        console.log('当前新增项:', this.processCurrentItem);
        console.log('FormData内容:');
        for (let pair of formData.entries()) {
          console.log(pair[0], pair[1]);
        }
        console.log('请求URL:', 'createViolation API');
        console.log('请求方法:', 'POST');
        console.log('========================');
        
        // 确保violate_id有值
        if (!this.processCurrentItem.violationNumber) {
          alert('违规编号不能为空');
          return;
        }
        
        // 使用新的时间格式化函数，确保格式正确
        if (this.processCurrentItem.violationTime) {
          this.processCurrentItem.violationTime = this.formatTimeForBackend(this.processCurrentItem.violationTime);
        }
        
        console.log('发送的violate_id:', this.processCurrentItem.violationNumber);
        
        const response = await createViolation(formData);
        
        // 详细打印响应信息
        console.log('=== 处理流程新增接口响应调试信息 ===');
        console.log('响应状态:', response.status);
        console.log('响应状态文本:', response.statusText);
        console.log('响应头:', response.headers);
        console.log('响应数据:', response.data);
        console.log('完整响应对象:', response);
        console.log('========================');
        
        if (response.data.status === 'success') {
          alert('新增成功');
          this.closeProcessDetail();
          this.searchProcess(); // 重新加载列表
        } else {
          alert('新增失败: ' + (response.data.message || '未知错误'));
        }
      } catch (error) {
        console.error('=== 处理流程新增接口调用失败 ===');
        console.error('错误详情:', error);
        console.error('错误消息:', error.message);
        console.error('错误堆栈:', error.stack);
        console.error('========================');
        alert('新增失败，请查看控制台');
      }
    },
    // 添加设备维修相关方法
    showRepairView(item) {
      this.repairCurrentItem = { ...item };
      this.repairViewMode = 'view';
    },
    showRepairEdit(item) {
      this.repairCurrentItem = { ...item };
      this.repairViewMode = 'edit';
    },
    closeRepairDetail() {
      this.repairViewMode = 'list';
      this.repairCurrentItem = null;
    },
    closePointAdd() {
      this.pointAddMode = false;
    },
    async savePointAdd() {
      try {
        // 表单验证：检查必填字段
        const requiredFields = {
          '设备编号': this.pointAddItem.fac_id,
          '设备名称': this.pointAddItem.fac_name,
          '设备类型': this.pointAddItem.fac_model,
          '设备状态': this.pointAddItem.fac_state,
          '详细位置': this.pointAddItem.detail_location,
          '所属厂区': this.pointAddItem.factory_area,
          '生产厂家': this.pointAddItem.manufacturer,
          '申报人': this.pointAddItem.applicant
        };
        
        const emptyFields = [];
        for (const [fieldName, value] of Object.entries(requiredFields)) {
          if (!value || value.trim() === '') {
            emptyFields.push(fieldName);
          }
        }
        
        if (emptyFields.length > 0) {
          alert(`请补全信息：${emptyFields.join('、')}`);
          return;
        }
        

        
        // 处理日期字段，如果为空则设置默认值
        if (!this.pointAddItem.install_date) {
          this.pointAddItem.install_date = this.formatDateForAPI(new Date().toISOString());
        }
        
        // 使用新的时间格式化函数，确保格式正确
        if (this.pointAddItem.install_date) {
          this.pointAddItem.install_date = this.formatTimeForBackend(this.pointAddItem.install_date);
        }
        
        const formData = new FormData();
        for (const key in this.pointAddItem) {
          if (key === 'install_photo' && this.pointAddItem.install_photo) {
            // base64转Blob
            const arr = this.pointAddItem.install_photo.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            const blob = new Blob([u8arr], { type: mime });
            formData.append('install_photo', blob, 'install_photo.jpg');
          } else {
            formData.append(key, this.pointAddItem[key]);
          }
        }
        
        // 打印请求参数用于调试
        console.log('=== 点位管理新增接口调用调试信息 ===');
        console.log('新增数据:', this.pointAddItem);
        console.log('FormData内容:');
        for (let pair of formData.entries()) {
          console.log(pair[0], pair[1]);
        }
        console.log('请求URL:', 'createPointMessage API');
        console.log('请求方法:', 'POST');
        console.log('========================');
        
        const response = await createPointMessage(formData);
        
        // 打印响应信息用于调试
        console.log('=== 点位管理新增接口响应调试信息 ===');
        console.log('响应状态:', response.status);
        console.log('响应数据:', response.data);
        console.log('========================');
        
        if (response.data.status === 'success') {
          this.pointAddMode = false;
          alert('新增成功！请联系研发人员将设备接入平台。');
          this.searchPoint(); // 重新加载列表
        } else {
          alert('新增失败');
        }
      } catch (error) {
        console.error('新增点位失败', error);
        alert('新增失败，请查看控制台');
      }
    },
    onPointAddImageChange(e) {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (ev) => {
          this.pointAddItem.install_photo = ev.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    onHistoryEditImageChange(e) {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (ev) => {
          this.historyCurrentItem.imageUrl = ev.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    closeRepairAdd() {
      this.repairAddMode = false;
    },
    async saveRepairAdd() {
      try {
        // 验证必填字段
        if (!this.repairAddItem.deviceNumber || !this.repairAddItem.deviceName || !this.repairAddItem.reporter) {
          alert('请填写设备编号、设备名称和申报人信息');
          return;
        }
        
        // 使用新的时间格式化函数，确保格式正确
        if (this.repairAddItem.reportTime) {
          this.repairAddItem.reportTime = this.formatTimeForBackend(this.repairAddItem.reportTime);
        }
        
        if (this.repairAddItem.solveTime) {
          this.repairAddItem.solveTime = this.formatTimeForBackend(this.repairAddItem.solveTime);
        }
        
         // 根据设备编号获取对应的安装位置
         const location = this.deviceLocationMap[this.repairAddItem.deviceNumber] || '';
        
        // 使用FormData发送数据，包含图片
        const formData = new FormData();
        formData.append('maintenance_id', this.generateMaintenanceId());
        formData.append('fac_id', this.repairAddItem.deviceNumber);
        formData.append('fac_name', this.repairAddItem.deviceName);
        formData.append('fac_point', location);
        formData.append('applicant', this.repairAddItem.reporter || '');
        formData.append('applicant_date', this.repairAddItem.reportTime || this.formatDateForAPI(new Date().toISOString()));
        formData.append('fault_description', this.repairAddItem.faultDesc || '');
        formData.append('resolution_state', this.repairAddItem.solveStatus || '未解决');
        formData.append('resolution_description', this.repairAddItem.solveDesc || '');
        formData.append('resolution_people', this.repairAddItem.solver || '');
        formData.append('resolution_date', this.repairAddItem.solveTime || '');
        
        // 添加图片数据
        if (this.repairAddItem.faultImage) {
          // 将base64转换为Blob
          const faultBlob = this.dataURLtoBlob(this.repairAddItem.faultImage);
          formData.append('fault_photo', faultBlob, 'fault_photo.jpg');
        }
        
        if (this.repairAddItem.solveImage) {
          // 将base64转换为Blob
          const solveBlob = this.dataURLtoBlob(this.repairAddItem.solveImage);
          formData.append('resolution_photo', solveBlob, 'resolution_photo.jpg');
        }
        
        // 详细打印请求信息
        console.log('=== 设备维修新增接口调用调试信息 ===');
        console.log('当前新增项:', this.repairAddItem);
        console.log('FormData内容:');
        for (let pair of formData.entries()) {
          console.log(pair[0], pair[1]);
        }
        console.log('请求URL:', 'createMaintenance API');
        console.log('请求方法:', 'POST');
        console.log('========================');
        
        const response = await createMaintenance(formData);
               
        // 详细打印响应信息
        console.log('=== 设备维修新增接口响应调试信息 ===');
        console.log('响应状态:', response.status);
        console.log('响应状态文本:', response.statusText);
        console.log('响应头:', response.headers);
        console.log('响应数据:', response.data);
        console.log('完整响应对象:', response);
        console.log('========================');
        
        if (response.data.status === 'success') {
          alert('新增成功');
          this.repairAddMode = false;
          this.searchRepair(); // 重新加载列表
        } else {
          alert('新增失败: ' + (response.data.message || '未知错误'));
        }
      } catch (error) {
        console.error('=== 设备维修新增接口调用失败 ===');
        console.error('错误详情:', error);
        console.error('错误消息:', error.message);
        console.error('错误堆栈:', error.stack);
        console.error('========================');
        alert('新增失败，请查看控制台');
      }
    },
    
    async saveRepairEdit() {
      try {
        // 验证必填字段
        if (!this.repairCurrentItem.deviceNumber || !this.repairCurrentItem.deviceName) {
          alert('请填写设备编号和设备名称信息');
          return;
        }
        
        // 使用新的时间格式化函数，确保格式正确
        if (this.repairCurrentItem.reportTime) {
          this.repairCurrentItem.reportTime = this.formatTimeForBackend(this.repairCurrentItem.reportTime);
        }
        
        if (this.repairCurrentItem.solveTime) {
          this.repairCurrentItem.solveTime = this.formatTimeForBackend(this.repairCurrentItem.solveTime);
        }
        
        // 根据设备编号获取对应的安装位置
        const location = this.deviceLocationMap[this.repairCurrentItem.deviceNumber] || this.repairCurrentItem.installLocation;
        
        // 使用FormData发送数据，包含图片
        const formData = new FormData();
        formData.append('maintenance_id', this.repairCurrentItem.maintenance_id);
        formData.append('fac_id', this.repairCurrentItem.deviceNumber);
        formData.append('fac_name', this.repairCurrentItem.deviceName);
        formData.append('fac_point', location);
        formData.append('applicant', this.repairCurrentItem.reporter || '');
        formData.append('applicant_date', this.repairCurrentItem.reportTime || this.formatDateForAPI(new Date().toISOString()));
        formData.append('fault_description', this.repairCurrentItem.faultDesc || '');
        formData.append('resolution_state', this.repairCurrentItem.solveStatus || '未解决');
        formData.append('resolution_description', this.repairCurrentItem.solveDesc || '');
        formData.append('resolution_people', this.repairCurrentItem.solver || '');
        formData.append('resolution_date', this.repairCurrentItem.solveTime || '');
        
        // 添加图片数据
        if (this.repairCurrentItem.faultImage) {
    // 将base64转换为Blob
    const faultBlob = this.dataURLtoBlob(this.repairCurrentItem.faultImage);
    if (faultBlob) {
      formData.append('fault_photo', faultBlob, 'fault_photo.jpg');
    } else {
      console.warn('faultImage 转换失败，跳过此图片');
    }
  }

  if (this.repairCurrentItem.solveImage) {
    // 将base64转换为Blob
    const solveBlob = this.dataURLtoBlob(this.repairCurrentItem.solveImage);
    if (solveBlob) {
      formData.append('resolution_photo', solveBlob, 'resolution_photo.jpg');
    } else {
      console.warn('solveImage 转换失败，跳过此图片');
    }
  }
        
        // 详细打印请求信息
        console.log('=== 设备维修编辑接口调用调试信息 ===');
        console.log('当前编辑项:', this.repairCurrentItem);
        console.log('FormData内容:');
        for (let pair of formData.entries()) {
          console.log(pair[0], pair[1]);
        }
        console.log('请求URL:', 'createMaintenance API');
        console.log('请求方法:', 'POST');
        console.log('========================');
        
        const response = await createMaintenance(formData);
        
        // 详细打印响应信息
        console.log('=== 设备维修编辑接口响应调试信息 ===');
        console.log('响应状态:', response.status);
        console.log('响应状态文本:', response.statusText);
        console.log('响应头:', response.headers);
        console.log('响应数据:', response.data);
        console.log('完整响应对象:', response);
        console.log('========================');
        
        if (response.data.status === 'success') {
          alert('保存成功');
          this.closeRepairDetail();
          this.searchRepair(); // 重新加载列表
        } else {
          alert('保存失败: ' + (response.data.message || '未知错误'));
        }
      } catch (error) {
        console.error('=== 设备维修编辑接口调用失败 ===');
        console.error('错误详情:', error);
        console.error('错误消息:', error.message);
        console.error('错误堆栈:', error.stack);
        console.error('========================');
        alert('保存失败，请查看控制台');
      }
    },
    
    // async deleteRepair(item) {
    //   if (confirm(`确定要删除设备 "${item.deviceName || '未知设备'}" 的维修记录吗？`)) {
    //     try {
    //       // 这里可以调用删除API，目前先从前端列表中移除
    //       // const response = await deleteMaintenance(item.maintenance_id);
    //       // if (response.data.status === 'success') {
    //       //   alert('删除成功');
    //       //   this.searchRepair(); // 重新加载列表
    //       // } else {
    //       //   alert('删除失败: ' + (response.data.message || '未知错误'));
    //       // }
          
    //       // 暂时从前端列表中移除（模拟删除）
    //       const index = this.repairList.findIndex(repair => repair.maintenance_id === item.maintenance_id);
    //       if (index > -1) {
    //         this.repairList.splice(index, 1);
    //         alert('删除成功');
    //       }
    //     } catch (error) {
    //       console.error('删除维修信息失败:', error);
    //       alert('删除失败，请查看控制台');
    //     }
    //   }
    // },
    onRepairAddImageChange(e, type) {
      console.log('=== 图片上传开始 ===');
      console.log('事件对象:', e);
      console.log('类型:', type);
      console.log('文件列表:', e.target.files);
      
      const file = e.target.files[0];
      if (file) {
        console.log('选择的文件:', file);
        console.log('文件大小:', file.size, 'bytes');
        console.log('文件类型:', file.type);
        
        const reader = new FileReader();
        reader.onload = (ev) => {
          console.log('文件读取完成');
          console.log('读取结果类型:', typeof ev.target.result);
          console.log('读取结果长度:', ev.target.result.length);
          
          if (type === 'fault') {
            this.repairAddItem.faultImage = ev.target.result;
            console.log('故障图片已设置，长度:', this.repairAddItem.faultImage.length);
          } else {
            this.repairAddItem.solveImage = ev.target.result;
            console.log('解决图片已设置，长度:', this.repairAddItem.solveImage.length);
          }
          
          // 强制更新视图
          this.$forceUpdate();
          console.log('=== 图片上传完成 ===');
        };
        
        reader.onerror = (error) => {
          console.error('文件读取失败:', error);
        };
        
        reader.readAsDataURL(file);
      } else {
        console.warn('没有选择文件');
      }
    },
    onRepairDetailImageChange(e, type) {
      console.log('=== 编辑弹窗图片上传开始 ===');
      console.log('事件对象:', e);
      console.log('类型:', type);
      console.log('文件列表:', e.target.files);
      
      const file = e.target.files[0];
      if (file) {
        console.log('选择的文件:', file);
        console.log('文件大小:', file.size, 'bytes');
        console.log('文件类型:', file.type);
        
        const reader = new FileReader();
        reader.onload = (ev) => {
          console.log('文件读取完成');
          console.log('读取结果类型:', typeof ev.target.result);
          console.log('读取结果长度:', ev.target.result.length);
          
          if (type === 'fault') {
            this.repairCurrentItem.faultImage = ev.target.result;
            console.log('故障图片已设置，长度:', this.repairCurrentItem.faultImage.length);
          } else {
            this.repairCurrentItem.solveImage = ev.target.result;
            console.log('解决图片已设置，长度:', this.repairCurrentItem.solveImage.length);
          }
          
          // 强制更新视图
          this.$forceUpdate();
          console.log('=== 编辑弹窗图片上传完成 ===');
        };
        
        reader.onerror = (error) => {
          console.error('文件读取失败:', error);
        };
        
        reader.readAsDataURL(file);
      } else {
        console.warn('没有选择文件');
      }
    },
    // 将base64图片转换为Blob
    dataURLtoBlob(dataURL) {
      // 验证输入参数
      if (!dataURL || typeof dataURL !== 'string') {
        console.error('dataURLtoBlob: 无效的输入参数', dataURL);
        return null;
      }
      
      const arr = dataURL.split(',');
      if (arr.length !== 2) {
        console.error('dataURLtoBlob: 无效的dataURL格式', dataURL);
        return null;
      }
      
      // 安全地提取MIME类型
      const mimeMatch = arr[0].match(/:(.*?);/);
      if (!mimeMatch) {
        console.error('dataURLtoBlob: 无法提取MIME类型', arr[0]);
        return null;
      }
      
      const mime = mimeMatch[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    goToPatrol() {
      window.location.href = 'http://47.93.132.27:5050/';
    },
    
    // 车辆类型映射方法
    mapVehicleType(deviceType) {
      const typeMap = {
        'truck': '货车',
        'lightTruck': '轻微货车',
        'mediumHeavyTruck': '中重型货车',
        'minitruck': '微卡',
        'containerTruck': '集装箱卡车',
        'oilTankTruck': '油罐车',
        'slagTruck': '渣土车',
        'pickupTruck': '小货车',
        'platformTrailer': '平板拖车',
        'concreteMixer': '混凝土搅拌车',
        'crane': '吊车',
        'bus': '客车',
        'largeBus': '大型客车',
        'mediumBus': '中型客车',
        'minibus': '小型客车',
        'saloon': '三厢轿车',
        'coupe': '轿跑',
        'hatchback': '两厢轿车',
        'SUVMPV': 'SUV/MPV',
        'van': '面包车',
        'smallCar': '小型轿车',
        'miniCar': '微型轿车',
        'motorVehicle': '机动车',
        'nonmotorVehicle': '非机动车',
        'threeWheelVehicle': '三轮车',
        'twoWheelVehicle': '二轮车',
        'pedestrian': '行人',
        'unknown': '未知',
        'vehicle': '轿车'
      };
      return typeMap[deviceType] || '未知';
    },
    
    // 时间格式化方法
    formatTime(timeString) {
      if (!timeString) return '';
      try {
        // 尝试解析ISO格式时间
        const date = new Date(timeString);
        if (isNaN(date.getTime())) {
          return timeString; // 如果解析失败，返回原字符串
        }
        return date.toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
          // 移除秒的显示，精确到分钟
        });
      } catch (error) {
        return timeString;
      }
    },

    // 新增：将时间转换为后端期望的格式
    formatTimeForBackend(timeString) {
      if (!timeString) return '';
      try {
        let date;
        
        // 如果已经是ISO格式，直接使用
        if (timeString.includes('T') || timeString.includes('-')) {
          date = new Date(timeString);
        } else {
          // 如果是其他格式，尝试解析
          date = new Date(timeString);
        }
        
        if (isNaN(date.getTime())) {
          console.warn('时间解析失败:', timeString);
          return timeString;
        }
        
        // 格式化为 YYYY-MM-DD HH:MM:SS 格式
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } catch (error) {
        console.error('时间格式化失败:', error);
        return timeString;
      }
    },

    // 新增：将日期时间转换为API期望的YYYY-MM-DD格式
    formatDateForAPI(dateTimeString) {
      if (!dateTimeString) return '';
      try {
        let date;
        
        // 如果已经是ISO格式，直接使用
        if (dateTimeString.includes('T') || dateTimeString.includes('-')) {
          date = new Date(dateTimeString);
        } else {
          // 如果是其他格式，尝试解析
          date = new Date(dateTimeString);
        }
        
        if (isNaN(date.getTime())) {
          console.warn('日期解析失败:', dateTimeString);
          return '';
        }
        
        // 格式化为 YYYY-MM-DD HH:mm:ss 格式
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } catch (error) {
        console.error('日期格式化失败:', error);
        return '';
      }
    },

 
    // 新增：通过中间件获取抓拍图片的方法
    async getCaptureImage(imageData, captureTime) {
      if (!imageData || !captureTime) {
        console.warn('缺少图片数据或抓拍时间');
        return null;
      }

      try {
        console.log('=== 开始获取抓拍图片 ===');
        console.log('图片数据:', imageData);
        console.log('抓拍时间:', captureTime);

        // 第一步：查询图片信息，获取fileName
        const picRecInfoXml = `<?xml version="1.0" encoding="utf-8"?>
<PicRecInfoSearchDescription>
  <targetEndpoint>/ISAPI/Traffic/ContentMgmt/picRecInfo</targetEndpoint>
  <searchID>CB5062A2-B830-0001-D958-B1D71C28DDE0</searchID>
  <VehicleList>
    <Vehicle>
      <vehicleID>CB5062A2-B830-0001-4E47-1C3018347BE0</vehicleID>
      <channel>${imageData.channel || '0'}</channel>
      <ctrl>${imageData.ctrl || '0'}</ctrl>
      <drive>${imageData.drive || '0'}</drive>
      <part>${imageData.part || '0'}</part>
      <fileNo>${imageData.fileNo || ''}</fileNo>
      <startOffset>${imageData.startOffset || ''}</startOffset>
      <picLen>${imageData.picLen || ''}</picLen>
      <captureTime>${captureTime}</captureTime>
      <violationType/>
    </Vehicle>
  </VehicleList>
</PicRecInfoSearchDescription>`;

        console.log('查询图片信息XML:', picRecInfoXml);

        // 通过中间件查询图片信息
        const picRecInfoResponse = await fetch('http://47.93.132.27:10000/api/device/request', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/xml',
          },
          body: picRecInfoXml
        });

        if (!picRecInfoResponse.ok) {
          throw new Error(`查询图片信息失败: ${picRecInfoResponse.status}`);
        }

        const picRecInfoText = await picRecInfoResponse.text();
        console.log('图片信息查询响应:', picRecInfoText);

        // 解析响应获取fileName
        let fileName = null;
        try {
          // 尝试解析JSON响应
          const jsonResponse = JSON.parse(picRecInfoText);
          if (jsonResponse.success && jsonResponse.data) {
            // 解析XML数据获取第二个fileName
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(jsonResponse.data, 'text/xml');
            const fileNameElements = xmlDoc.querySelectorAll('fileName');
            if (fileNameElements && fileNameElements.length >= 2) {
              // 获取第二个fileName字段
              fileName = fileNameElements[1].textContent;
              console.log('获取到第二个fileName:', fileName);
            } else if (fileNameElements && fileNameElements.length === 1) {
              // 如果只有一个fileName，使用第一个
              fileName = fileNameElements[0].textContent;
              console.log('只有一个fileName，使用第一个:', fileName);
            }
          }
        } catch (jsonError) {
          // 如果不是JSON，尝试直接解析XML
          try {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(picRecInfoText, 'text/xml');
            const fileNameElements = xmlDoc.querySelectorAll('fileName');
            if (fileNameElements && fileNameElements.length >= 2) {
              // 获取第二个fileName字段
              fileName = fileNameElements[1].textContent;
              console.log('获取到第二个fileName:', fileName);
            } else if (fileNameElements && fileNameElements.length === 1) {
              // 如果只有一个fileName，使用第一个
              fileName = fileNameElements[0].textContent;
              console.log('只有一个fileName，使用第一个:', fileName);
            }
          } catch (xmlError) {
            console.error('解析XML响应失败:', xmlError);
          }
        }

        if (!fileName) {
          console.warn('未能获取到fileName，尝试使用默认方式');
          // 如果无法获取fileName，尝试使用其他方式
          return await this.getImageByAlternativeMethod(imageData, captureTime);
        }
        
        console.log('获取到fileName:', fileName);

        // 第二步：通过fileName获取图片
        console.log('准备调用图片接口，fileName:', fileName);
        
        // 直接调用中间件的图片接口
        try {
          const pictureUrl = `http://47.93.132.27:10000/api/device/picture/${encodeURIComponent(fileName)}`;
          console.log('图片接口URL:', pictureUrl);
          
          const pictureResponse = await fetch(pictureUrl, {
            method: 'GET',
            headers: {
              'Accept': 'image/*',
            }
          });
          
          console.log("pictureResponse:", pictureResponse);
          console.log("响应状态:", pictureResponse.status, pictureResponse.statusText);
          console.log("响应头:", Object.fromEntries(pictureResponse.headers.entries()));
          
          if (!pictureResponse.ok) {
            throw new Error(`获取图片失败: ${pictureResponse.status}`);
          }
          
          const pictureData = await pictureResponse.blob();
          console.log('获取到图片数据:', pictureData);
          console.log('图片大小:', pictureData.size, 'bytes');
          console.log('图片类型:', pictureData.type);
          
          // 将图片数据转换为base64格式并打印
          const reader = new FileReader();
          reader.onload = () => {
            const base64Data = reader.result;
            console.log('图片base64数据(前100字符):', base64Data.substring(0, 100));
            console.log('图片base64数据长度:', base64Data.length);
          };
          reader.readAsDataURL(pictureData);
          
          // 创建图片URL用于显示
          const imageUrl = URL.createObjectURL(pictureData);
          console.log('创建的图片URL:', imageUrl);
          
          return imageUrl;
          
        } catch (pictureError) {
          console.error('获取图片失败:', pictureError);
          return null;
        }



      } catch (error) {
        console.error('获取抓拍图片失败:', error);
        

      }
    },



    // 为告警列表项添加图片
    async addImageToAlarm(alarmItem) {
      if (!alarmItem.imageData || alarmItem.imageUrl) {
        return; // 已有图片或没有图片数据，跳过
      }

      try {
        // 新的数据格式中，图片URL直接存储在violation_photo字段中
        if (alarmItem.imageData.violation_photo) {
          // 转换图片URL格式并直接使用violation_photo作为图片URL
          alarmItem.imageUrl = this.convertImageUrl(alarmItem.imageData.violation_photo);
          console.log('实时告警图片加载成功，使用violation_photo:', alarmItem.imageUrl);
          
          // 如果当前选中的是这个告警，更新显示的图片
          if (this.selectedAlarm === alarmItem) {
            this.currentImage = alarmItem.imageUrl;
          }
        } else {
          // 如果没有violation_photo，尝试使用旧的getCaptureImage方法
        const imageUrl = await this.getCaptureImage(
          alarmItem.imageData, 
          alarmItem.originalCaptureTime || alarmItem.updateTime
        );
        
        if (imageUrl) {
          alarmItem.imageUrl = imageUrl;
          // 如果当前选中的是这个告警，更新显示的图片
          if (this.selectedAlarm === alarmItem) {
            this.currentImage = imageUrl;
            }
          }
        }
      } catch (error) {
        console.error('为告警项添加图片失败:', error);
      }
    },

    // 只加载第一个告警的图片
    async loadFirstAlarmImage() {
      if (this.alarmList.length === 0) return;
      
      const firstAlarm = this.alarmList[0];
      if (firstAlarm.imageData && !firstAlarm.imageUrl) {
        try {
          console.log('自动加载第一个告警图片:', firstAlarm);
          
          // 新的数据格式中，图片URL直接存储在violation_photo字段中
          if (firstAlarm.imageData.violation_photo) {
            // 转换图片URL格式并直接使用violation_photo作为图片URL
            firstAlarm.imageUrl = this.convertImageUrl(firstAlarm.imageData.violation_photo);
            console.log('实时告警图片加载成功，使用violation_photo:', firstAlarm.imageUrl);
            
            // 如果当前没有选中的告警，自动选中第一个并显示图片
            if (!this.selectedAlarm) {
              this.selectAlarm(firstAlarm);
            }
          } else {
            // 如果没有violation_photo，尝试使用旧的getCaptureImage方法
          const imageUrl = await this.getCaptureImage(
            firstAlarm.imageData,
            firstAlarm.originalCaptureTime || firstAlarm.updateTime
          );
          
          if (imageUrl) {
            firstAlarm.imageUrl = imageUrl;
            // 如果当前没有选中的告警，自动选中第一个并显示图片
            if (!this.selectedAlarm) {
              this.selectAlarm(firstAlarm);
              }
            }
          }
        } catch (error) {
          console.error('自动加载第一个告警图片失败:', error);
        }
      }
    },

    // 为历史记录列表项添加图片
    async addImageToHistory(historyItem) {
      if (!historyItem.imageData || historyItem.imageUrl) {
        return; // 已有图片或没有图片数据，跳过
      }

      try {
        // 新的数据格式中，图片URL直接存储在violation_photo字段中
        if (historyItem.imageData.violation_photo) {
          // 转换图片URL格式并直接使用violation_photo作为图片URL
          historyItem.imageUrl = this.convertImageUrl(historyItem.imageData.violation_photo);
          console.log('历史记录图片加载成功，使用violation_photo:', historyItem.imageUrl);
        } else {
          // 如果没有violation_photo，尝试使用旧的getCaptureImage方法
          const imageUrl = await this.getCaptureImage(
            historyItem.imageData, 
            historyItem.originalCaptureTime || historyItem.violationTime
          );
          
          if (imageUrl) {
            historyItem.imageUrl = imageUrl;
          }
        }
      } catch (error) {
        console.error('为历史记录项添加图片失败:', error);
      }
    },



    // 手动加载历史记录图片
    async loadHistoryImage(historyItem) {
      if (!historyItem || !historyItem.imageData) {
        console.warn('没有图片数据可加载');
        return;
      }

      try {
        console.log('手动加载历史记录图片:', historyItem);
        
        // 新的数据格式中，图片URL直接存储在violation_photo字段中
        if (historyItem.imageData.violation_photo) {
          // 转换图片URL格式并直接使用violation_photo作为图片URL
          historyItem.imageUrl = this.convertImageUrl(historyItem.imageData.violation_photo);
          console.log('历史记录图片加载成功，使用violation_photo:', historyItem.imageUrl);
        } else {
          // 如果没有violation_photo，尝试使用旧的getCaptureImage方法
          const imageUrl = await this.getCaptureImage(
            historyItem.imageData,
            historyItem.originalCaptureTime || historyItem.violationTime
          );
          
          if (imageUrl) {
            historyItem.imageUrl = imageUrl;
            console.log('历史记录图片加载成功');
          } else {
            console.warn('历史记录图片加载失败');
          }
        }
      } catch (error) {
        console.error('手动加载历史记录图片失败:', error);
      }
    },
    generateMaintenanceId() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      return `${year}${month}${day}${hours}${minutes}`;
    },


    // 新增：刷新当前标签页数据的方法
    refreshCurrentTab() {
      console.log('刷新当前标签页:', this.activeTab);
      
      switch (this.activeTab) {
        case '实时告警':
          this.searchAlarm();
          break;
        case '历史查询':
          this.searchHistory();
          break;
        case '点位管理':
          this.searchPoint();
          break;
        case '处理流程':
          this.searchProcess();
          break;
        case '设备维修':
          this.searchRepair();
          break;
        default:
          console.warn('未知的标签页:', this.activeTab);
      }
    },
    // 修改历史查询的打印功能
    async printHistory() {
      try {
        console.log('=== 开始打印历史查询数据 ===');
        
        // 构建查询参数，设置perpage为500获取所有数据
        const params = {
          plate_number: this.historyQuery.plateNumber || '',
          install_area: this.historyQuery.location || '',
          fac_id: this.historyQuery.deviceNumber || '',
          start_date: this.historyQuery.startDate ? this.formatDateForAPI(this.historyQuery.startDate) : '',
          end_date: this.historyQuery.endDate ? this.formatDateForAPI(this.historyQuery.endDate) : '',
          page: 1, // 从第一页开始
          per_page: 500 // 设置每页500条数据
        };
        
        console.log('打印查询参数:', params);
        
        // 调用API获取所有数据
        const response = await queryViolations(params);
        
        console.log('打印API响应:', response);
        
        let allHistoryData = [];
        
        // 检查响应数据结构
        if (response.data && Array.isArray(response.data.data)) {
          console.log('API返回数据:', response.data);
          console.log('数据数组长度:', response.data.data.length);
          
          // 转换API返回的数据格式为前端需要的格式
          allHistoryData = response.data.data.map((item, index) => {
            console.log(`处理第${index + 1}条打印数据:`, item);
            
            // 解码Unicode编码的中文字符
            const decodeUnicode = (str) => {
              if (!str) return str;
              return str.replace(/\\u([0-9a-fA-F]{4})/g, (match, hex) => {
                return String.fromCharCode(parseInt(hex, 16));
              });
            };
            
            const processedItem = {
              id: item.violate_id || index + 1,
              deviceNumber: decodeUnicode(item.fac_id) || '未知设备',
              deviceName: decodeUnicode(item.fac_name) || '雷视一体机',
              location: decodeUnicode(item.install_area) || '未知位置',
              vehicleType: '货车', // 默认车辆类型
              plateNumber: decodeUnicode(item.plate_number) || '无车牌',
              violationTime: item.violate_date ? this.formatTime(item.violate_date) : '',
              speed: item.speed ? `${item.speed}km/h` : ''
            };
            
            console.log(`处理后的打印数据第${index + 1}项:`, processedItem);
            return processedItem;
          });
          
          console.log('最终打印数据列表:', allHistoryData);
          console.log('打印数据列表长度:', allHistoryData.length);
        } else {
          console.error('打印数据获取失败: 响应数据格式不正确');
          console.error('response.data:', response.data);
          allHistoryData = [];
        }
        
        // 生成打印内容
        const printContent = `
          <div style="padding: 20px;">
            <h2 style="text-align: center; margin-bottom: 20px;">历史查询列表</h2>
            <div style="margin-bottom: 10px; text-align: right; color: #666;">
              打印时间: ${new Date().toLocaleString('zh-CN')}
            </div>
            <div style="margin-bottom: 10px; text-align: right; color: #666;">
              总记录数: ${allHistoryData.length} 条
            </div>
            <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
              <thead>
                <tr style="background: #f5f5f5;">
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">序号</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备编号</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备名称</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">安装位置</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">车辆类型</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">车牌号</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">违规时间</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">车速</th>
                </tr>
              </thead>
              <tbody>
                ${allHistoryData.map((item, idx) => `
                  <tr>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${idx + 1}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.deviceNumber}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.deviceName}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.location}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.vehicleType}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.plateNumber}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.violationTime}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.speed}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>
        `;
        
        // 打开打印窗口
        const printWindow = window.open('', '_blank');
        printWindow.document.write(printContent);
        printWindow.document.close();
        printWindow.print();
        printWindow.close();
        
        console.log('=== 历史查询打印完成 ===');
        
      } catch (error) {
        console.error('打印历史查询数据失败:', error);
        alert('打印失败，请查看控制台');
      }
    },
  }
}
</script>

<style scoped>
/* 样式内容 */
</style>
